webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);

var eBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(181);





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    checkEntrance: false,
    socket: null,
    peerInfo: {},
    streamInfo: {},
    roomInfo: {},
    userInfo: {},
    showsSpeaker: false,
    language: '',
    videoOnMembers: [],
    videoOffMembers: [],
    videoStatus: {},
    highResolution: false
  },
  mutations: {
    setSocketIo: function setSocketIo(state, socket) {
      state.socket = socket;
    },
    setPeerInfo: function setPeerInfo(state, peer) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.peerInfo, peer);
    },
    removePeerInfo: function removePeerInfo(state, name) {
      if (state.peerInfo[name]) {
        state.peerInfo[name].close();
        delete state.peerInfo[name];
      }

      console.log(name, 'ivypark peerInfo ----> ', state.peerInfo);
    },
    setStreamInfo: function setStreamInfo(state, info) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.streamInfo, info);
    },
    removeStreamInfo: function removeStreamInfo(state, name) {
      if (state.streamInfo[name]) {
        state.streamInfo[name].getTracks().forEach(function (track) {
          state.streamInfo[name].removeTrack(track); // 210303 모바일웹 종료 이슈 수정
          track.stop();
        });

        delete state.streamInfo[name];
      }

      console.log(name, 'ivypark streaminfo ----> ', state.streamInfo);
    },
    setRoomInfo: function setRoomInfo(state, info) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.roomInfo, info);
    },
    setUserInfo: function setUserInfo(state, info) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.userInfo, info);
    },
    setLanguage: function setLanguage(state, info) {
      state.language = info;
    },
    setShowsSpeaker: function setShowsSpeaker(state, shows) {
      // 화자감지 기능 on/off
      state.showsSpeaker = shows;
    },
    clearAll: function clearAll(state) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.streamInfo).length > 0) {
        var _loop = function _loop(c) {
          state.streamInfo[c].getTracks().forEach(function (track) {
            state.streamInfo[c].removeTrack(track); // 210303 모바일웹 종료 이슈 수정
            track.stop();
          });
        };

        for (var c in state.streamInfo) {
          _loop(c);
        }
        state.streamInfo = {};
      }

      for (var c in state.peerInfo) {
        state.peerInfo[c].close();
        delete state.peerInfo[c];
      }

      state.userInfo = {};
      state.roomInfo = {};
      if (state.socket) state.socket.close();
      state.socket = null;
      state.videoOnMembers = [];
      state.videoOffMembers = [];

      state.showsSpeaker = false;
      state.highResolution = false;
      state.language = '';
      state.videoStatus = {};
      state.checkEntrance = false;
    },
    setVideoOnMembers: function setVideoOnMembers(state, info) {
      state.videoOnMembers = info;
    },
    setVideoOffMembers: function setVideoOffMembers(state, info) {
      state.videoOffMembers = info;
    },
    setVideoStatus: function setVideoStatus(state, info) {
      if (!state.videoStatus[info.userId]) {
        state.videoStatus[info.userId] = { cam: info.cam, audioSafe: info.audioSafe, blur: info.blur, camOff: info.camOff, micOff: info.micOff };
      } else {
        if (info.hasOwnProperty('cam')) state.videoStatus[info.userId].cam = info.cam;
        if (info.hasOwnProperty('audioSafe')) state.videoStatus[info.userId].audioSafe = info.audioSafe;
        if (info.hasOwnProperty('blur')) state.videoStatus[info.userId].blur = info.blur;
        if (info.hasOwnProperty('camOff')) state.videoStatus[info.userId].camOff = info.camOff;
        if (info.hasOwnProperty('micOff')) state.videoStatus[info.userId].micOff = info.micOff;
      }
      // state.videoStatus[info.userId] = { cam: info.cam, audioSafe: info.audioSafe, blur: info.blur, mic: info.mic };
    },
    setResolution: function setResolution(state, resolution) {
      state.highResolution = resolution === 'high' ? true : false;
    },
    checkEntrance: function checkEntrance(state, _checkEntrance) {
      state.checkEntrance = _checkEntrance;
    }
  }
}));

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  version: 'v1.3.5 (0311)',
  env: 'PROD', // 'LOCAL', 'TB', 'PROD'
  socketIoUrl: {
    LOCAL: 'https://localhost:7103/SignalServer',
    TB: 'https://dev.knowledgetalk.co.kr:7100/SignalServer',
    PROD: 'https://knowledgetalk.co.kr:7103/SignalServer'
  },
  developerMode: false,
  privateMode: {
    switch: false,
    cpName: 'KnowledgePoint',
    cpCode: {
      LOCAL: 'KP-20200101-01',
      TB: 'KP-20200101-01',
      PROD: 'KP-20200101-01'
    },
    authKey: {
      LOCAL: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcENvZGUiOiJURVNULUpVU1RJTiIsImNwTmFtZSI6IlRlc3RDUF9KdXN0aW4iLCJhbGxvd01heFVzZXIiOjAsImFsbG93U3RhcnREYXRlIjoiMjAyMC0xMC0yMCIsImFsbG93RW5kRGF0ZSI6IjIwMjAtMTAtMjEiLCJpYXQiOjE2MDMxNzQ0NjJ9.1g5WwGACqN_6RXc1qScN7997xMrHOsqzueN8fkB4NoU', // knowledgepointtoken
      TB: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcENvZGUiOiJURVNULUpVU1RJTiIsImNwTmFtZSI6IlRlc3RDUF9KdXN0aW4iLCJhbGxvd01heFVzZXIiOjAsImFsbG93U3RhcnREYXRlIjoiMjAyMC0xMC0yMCIsImFsbG93RW5kRGF0ZSI6IjIwMjAtMTAtMjEiLCJpYXQiOjE2MDMxNzQ0NjJ9.1g5WwGACqN_6RXc1qScN7997xMrHOsqzueN8fkB4NoU', // knowledgepointtoken
      PROD: '' // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoi64Kg66as7KeA7Y-s7J247Yq4IiwibWF4VXNlciI6IjUwMDAwMDAwIiwic3RhcnREYXRlIjoiMjAyMC0wMS0wMVQwNjo0NzowMC4wMDBaIiwiZW5kRGF0ZSI6IjIwMzAtMTItMzFUMDY6NDc6MDAuMDAwWiIsImF1dGhDb2RlIjoiS1AtMjAyMDAxMDEtMDEiLCJjb21wYW55Q29kZSI6IkxJQy0wMSIsImlhdCI6MTU4NzUzODExNH0.73A0UiiMHJeIS8pIgoN4DfEWT4QCsMnXkO4uUdnfbYI
    }
  },
  iceServer: {
    LOCAL: {
      p2p: {
        iceServers: [{ urls: 'turn:dev.knowledgetalk.co.kr:46000', username: 'kpoint', credential: 'kpoint01' }, { urls: 'stun:dev.knowledgetalk.co.kr:46000' }]
      },
      media: {
        iceServers: [{ urls: 'stun:dev.knowledgetalk.co.kr:46000' }]
      }
    },
    TB: {
      p2p: {
        iceServers: [{ urls: 'turn:dev.knowledgetalk.co.kr:46000', username: 'kpoint', credential: 'kpoint01' }, { urls: 'stun:dev.knowledgetalk.co.kr:46000' }]
      },
      media: {
        iceServers: [{ urls: 'stun:dev.knowledgetalk.co.kr:46000' }]
      }
    },
    PROD: {
      p2p: {
        iceServers: [{ urls: 'stun:prod.stun.knowledgetalk.co.kr:46000' }, { urls: 'turn:prod.turn.knowledgetalk.co.kr:46000', username: 'kpoint', credential: 'kpoint01' }]
      },
      media: {
        iceServers: [{ urls: 'stun:prod.stun.knowledgetalk.co.kr:46000' }]
      }
    }
  }, // RELEASED
  constraints: {
    share: { width: 224, height: 126, frameRate: 10 }, // video constraint when screen sharing
    p2p: { width: 960, height: 540, frameRate: 15 }, // 1 by 1
    four: { width: 640, height: 360, frameRate: 12 }, // 2 by 2
    six: { width: 480, height: 270, frameRate: 12 }, // 3 by 2
    nine: { width: 320, height: 180, frameRate: 12 }, // 3 by 3
    twelve: { width: 320, height: 180, frameRate: 10 }, // 4 by 3
    sixteen: { width: 224, height: 126, frameRate: 10 } // 4 by 4
    // 210202 mz, 16자 해상도 변경
  },
  constraintsLow: {
    share: { width: 192, height: 108, frameRate: 10 }, // video constraint when screen sharing
    p2p: { width: 640, height: 360, frameRate: 15 }, // 1 by 1
    four: { width: 480, height: 270, frameRate: 12 }, // 2 by 2
    six: { width: 320, height: 180, frameRate: 12 }, // 3 by 2
    nine: { width: 224, height: 126, frameRate: 12 }, // 3 by 3
    twelve: { width: 224, height: 126, frameRate: 10 }, // 4 by 3
    sixteen: { width: 192, height: 108, frameRate: 10 } // 4 by 4
  },
  getConstraint: function getConstraint(isHighResolution) {
    if (isHighResolution === false) return this.constraintsLow;
    return this.constraints;
  },
  pingInterval: 50,
  lengthOfRoomId: 8,
  listOfDomains: ['localhost', 'ktgenie.com', 'cococall.net'],
  networkCheckInterval: 5000,
  networkCheckByNum: function networkCheckByNum(num) {
    var video = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!video) {
      return 4;
    } else if (num <= 2) {
      return 220;
    } else if (num <= 4) {
      return 170;
    } else if (num <= 6) {
      return 110;
    } else if (num <= 9) {
      return 64;
    } else if (num <= 12) {
      return 54;
    } else if (num <= 16) {
      return 32;
    } else if (num <= 20) {
      return 26;
    } else if (num <= 25) {
      return 23;
    }
  },
  badNetworkLevel: 0.8,
  goodNetworkLevel: 1.05
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onMessage; });
/* harmony export (immutable) */ __webpack_exports__["b"] = sendMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__webrtc__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mobile__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screenshare__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(9);













var onMessage = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resp) {
    var audioSafeStatus, members, stream, beforeCnt, _members, videoOnMembers, videoOffMembers, videoOnIdx, videoOffIdx;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.debug('[ ' + (resp.eventOp ? resp.eventOp : resp.signalOp) + ' ] Signal -> Web ', resp);

            if (!(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].privateMode.switch && resp.code === '412')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup', {
              on: true,
              type: 'Alert',
              title: '회의 참여',
              contents: '잘못된 경로로 접근하였습니다. 초기화면으로 이동합니다.',
              cancel: function cancel() {
                window.location.href = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].getPrivateUrl();
              }
            }));

          case 3:

            if (resp.code === '504') {
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo).length ? 'popup' : 'popup-main', {
                on: true,
                type: 'Alert',
                title: '서버 오류',
                contents: '서버와의 연결이 원활하지 않습니다. 잠시 후 다시 시도해주세요.',
                cancel: function cancel() {
                  window.location.href = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].getPrivateUrl();
                }
              });
            }

            //AudioSafe 관리 객체
            audioSafeStatus = {};
            _context.t0 = resp.eventOp || resp.signalOp;
            _context.next = _context.t0 === 'CreateRoom' ? 8 : _context.t0 === 'RoomJoin' ? 10 : _context.t0 === 'RoomJoinWithName' ? 12 : _context.t0 === 'StartSession' ? 14 : _context.t0 === 'SDP' ? 33 : _context.t0 === 'Candidate' ? 64 : _context.t0 === 'ReceiveFeed' ? 70 : _context.t0 === 'SendFeed' ? 72 : _context.t0 === 'SessionReserve' ? 73 : _context.t0 === 'ScreenShareConferenceEndSvr' ? 86 : _context.t0 === 'EditFeed' ? 88 : _context.t0 === 'Presence' ? 93 : _context.t0 === 'ChangeName' ? 95 : _context.t0 === 'SetAudio' ? 97 : _context.t0 === 'SetVideo' ? 100 : _context.t0 === 'Talking' ? 108 : 110;
            break;

          case 8:
            if (resp.code === '200') {
              //210218 add Entrance page 
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setRoomInfo', { roomId: resp.roomId, isHost: true });
              __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ path: (resp.cp ? '/' + resp.cp : '') + '/entrance/' + resp.roomId });
            }
            return _context.abrupt('break', 110);

          case 10:
            //210218 add Entrance page 
            receiveRoomJoin(resp);
            return _context.abrupt('break', 110);

          case 12:
            receiveRoomJoin(resp);
            return _context.abrupt('break', 110);

          case 14:
            sendMessage('StartSession', { code: '200' });
            if (resp.members) {
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setRoomInfo', {
                members: resp.members,
                count: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(resp.members).length,
                type: resp.useMediaSvr === 'Y' ? 'multi' : 'p2p'
                // host: resp.host
              });
              cocolib.audioSafe.update(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count);
              members = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(resp.members);
              //210202 mz, videoOnMembers 위치 변경 (RoomJoin, StartSession, Presence Op --> Peer connected)
              // let idx = members.indexOf(store.state.userInfo.id)
              // if(idx > 0){
              //   members.splice(members.indexOf(store.state.userInfo.id),1);
              //   members.splice(0,0,store.state.userInfo.id);
              // }
              // store.commit('setVideoOnMembers', members);
            }

            if (!(resp.useMediaSvr === 'Y')) {
              _context.next = 28;
              break;
            }

            if (!(resp.changeView || resp.who === __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.userInfo.id)) {
              _context.next = 26;
              break;
            }

            // 200619 ivypark, v0.9.3. 1:1 -> N:N 전환 시 화면공유 종료 (stream이 3번째 사용자에게 전달 되지 않음. 끊는 것이 날리지톡 정책)
            if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.streamInfo.screen) {
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('share', { type: 'remove' });
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup', { on: true, type: 'Alert', title: '화면 공유', contents: '다자 통화 화면 전환으로 인해 화면공유가 종료됩니다.' });
            }

            //when blur is on
            if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus['local'] && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus['local'].blur) {
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup', { on: true, type: 'Alert', title: '사생활 보호', contents: '다자 통화 화면 전환으로 인해 사생활 보호가 종료됩니다.' });
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('blurStop', {});
            }

            // 210303 모바일웹 종료 이슈 수정
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('removeStreamInfo', 'remote');
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('removePeerInfo', 'local');
            _context.next = 24;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createPeer('local', resp.useMediaSvr === 'Y', undefined, resp.host);

          case 24:
            _context.next = 26;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createOffer('local');

          case 26:
            _context.next = 32;
            break;

          case 28:
            _context.next = 30;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createPeer('local', resp.useMediaSvr === 'Y', undefined, resp.host);

          case 30:
            _context.next = 32;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createOffer('local');

          case 32:
            return _context.abrupt('break', 110);

          case 33:
            if (!(resp.code === '200')) {
              _context.next = 35;
              break;
            }

            return _context.abrupt('return');

          case 35:
            if (!(resp.usage === 'cam')) {
              _context.next = 50;
              break;
            }

            if (!(resp.sdp.type === 'offer')) {
              _context.next = 44;
              break;
            }

            _context.next = 39;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createPeer(resp.useMediaSvr === 'N' ? 'local' : resp.displayId, resp.useMediaSvr === 'Y', resp.pluginId);

          case 39:
            _context.next = 41;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createAnswer(resp.sdp, resp.useMediaSvr === 'N' ? 'local' : resp.displayId);

          case 41:
            sendMessage('SDP', { code: '200' });
            _context.next = 48;
            break;

          case 44:
            if (!(resp.sdp.type === 'answer')) {
              _context.next = 48;
              break;
            }

            _context.next = 47;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].setRemoteDescription(resp.sdp, 'local');

          case 47:
            sendMessage('SDP', { code: '200' });

          case 48:
            _context.next = 63;
            break;

          case 50:
            if (!(resp.usage === 'screen')) {
              _context.next = 63;
              break;
            }

            if (!(resp.sdp.type === 'offer')) {
              _context.next = 59;
              break;
            }

            _context.next = 54;
            return __WEBPACK_IMPORTED_MODULE_9__screenshare__["a" /* default */].createPeer('screen', resp.useMediaSvr === 'Y', resp.pluginId);

          case 54:
            _context.next = 56;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createAnswer(resp.sdp, 'screen');

          case 56:
            sendMessage('SDP', { code: '200' });
            _context.next = 63;
            break;

          case 59:
            if (!(resp.sdp.type === 'answer')) {
              _context.next = 63;
              break;
            }

            _context.next = 62;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].setRemoteDescription(resp.sdp, 'screen');

          case 62:
            sendMessage('SDP', { code: '200' });

          case 63:
            return _context.abrupt('break', 110);

          case 64:
            if (!(resp.usage === 'cam')) {
              _context.next = 69;
              break;
            }

            if (!resp.candidate) {
              _context.next = 68;
              break;
            }

            _context.next = 68;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].setCandidate(resp.candidate, resp.useMediaSvr === 'N' ? 'local' : resp.userId);

          case 68:
            sendMessage('Candidate', { code: '200' });

          case 69:
            return _context.abrupt('break', 110);

          case 70:
            // 210208, 0.5초당 1개의 sendfeed 전송
            resp.feeds.forEach(function (curr, idx) {
              (function (c, i) {
                setTimeout(function () {
                  sendMessage('SendFeed', { roomId: resp.roomId, feedId: c.id, display: c.display });
                }, 500 + 500 * i);
              })(curr, idx);
            });
            // TODO: 200728 ivypark, functionalization
            // resp.feeds.forEach(curr => {
            //   sendMessage('SendFeed', { roomId: resp.roomId, feedId: curr.id, display: curr.display });
            // })
            return _context.abrupt('break', 110);

          case 72:
            return _context.abrupt('break', 110);

          case 73:
            if (!(resp.code === '200')) {
              _context.next = 84;
              break;
            }

            _context.next = 76;
            return __WEBPACK_IMPORTED_MODULE_9__screenshare__["a" /* default */].createShareStream();

          case 76:
            stream = _context.sent;
            _context.next = 79;
            return __WEBPACK_IMPORTED_MODULE_9__screenshare__["a" /* default */].createPeer('screen', __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count > 2);

          case 79:
            _context.next = 81;
            return __WEBPACK_IMPORTED_MODULE_6__webrtc__["a" /* default */].createOffer('screen');

          case 81:
            __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('share', {
              type: 'add',
              id: 'screen',
              isLocal: true,
              stream: stream,
              count: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count
            });
            _context.next = 85;
            break;

          case 84:
            __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup', {
              on: true,
              type: 'Alert',
              title: '화면 공유',
              contents: '지금은 화면 공유를 진행할 수 없습니다.'
            });

          case 85:
            return _context.abrupt('break', 110);

          case 86:
            __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('share', {
              type: 'remove'
            });
            return _context.abrupt('break', 110);

          case 88:
            if (!(resp.code === '422')) {
              _context.next = 91;
              break;
            }

            console.error('EditFeed error! 422 :', resp);
            return _context.abrupt('return');

          case 91:
            if (resp.code === '200' && resp.video === true) {
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('networkCondition', {
                isGood: true,
                userId: resp.userId
              });
            } else if (resp.code === '200' && resp.video === false) {
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('networkCondition', {
                isGood: false,
                userId: resp.userId
              });
            }
            return _context.abrupt('break', 110);

          case 93:
            if (resp.action === 'exit') {
              beforeCnt = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count;
              _members = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.members;

              delete _members[resp.userId];
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setRoomInfo', { members: _members, count: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count - 1 });

              videoOnMembers = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoOnMembers;
              videoOffMembers = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoOffMembers;
              videoOnIdx = videoOnMembers.indexOf(resp.userId);
              videoOffIdx = videoOffMembers.indexOf(resp.userId);

              if (videoOnIdx > -1) {
                videoOnMembers.splice(videoOnIdx, 1);
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setVideoOnMembers', videoOnMembers);
              }

              if (videoOffIdx > -1) {
                videoOffMembers.splice(videoOffIdx, 1);
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setVideoOffMembers', videoOffMembers);
              }

              //화자감지 on 중 일대일 회의로 전환 시 처리
              if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.showsSpeaker && beforeCnt > 2 && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count == 2) {
                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup', {
                  on: true,
                  type: 'Alert',
                  title: '화자 감지',
                  contents: '일대일 회의 시 화자감지 기능이 종료됩니다.'
                });
                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('showsSpeaker', {
                  setShows: false
                });
              }

              //사생활보호 중 일대일 회의로 전환 시 처리
              if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count === 2 && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus['local'] && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus['local'].blur) {
                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('blurAgain', {});
              }

              //사생활보호 중 혼자 남아있을 경우
              if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count <= 1 && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus['local'] && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus['local'].blur) {
                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup', {
                  on: true,
                  type: 'Alert',
                  title: '사생활 보호',
                  contents: '다른 모든 사용자가 통화를 종료하여 사생활 보호가 종료됩니다.'
                });

                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('blurStop', {});
              }

              if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count <= 1 && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.peerInfo.hasOwnProperty('screen')) {
                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('share', {
                  type: 'remove',
                  isSharer: true
                });
                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup', {
                  on: true,
                  type: 'Alert',
                  title: '화면 공유',
                  contents: '다른 모든 사용자가 통화를 종료하여 화면공유가 종료됩니다.'
                });
              }

              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('video', {
                type: 'remove',
                count: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count,
                id: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.type === 'p2p' ? 'remote' : resp.userId
              });

              cocolib.audioSafe.update(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count);
            } else if (resp.action === 'join') {
              if (resp.members) __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setRoomInfo', { members: resp.members, count: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(resp.members).length });
              //210202 mz, videoOnMembers 위치 변경 (RoomJoin, StartSession, Presence Op --> Peer connected)
              // let members = store.state.videoOnMembers;
              if (resp.userId) {
                // members.push(resp.userId);
                // store.commit('setVideoOnMembers', members);
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setVideoStatus', { userId: resp.userId, cam: true, audioSafe: false });
              }
            } else if (resp.action === 'talking') {
              //화자감지 이벤트 수신
              if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.showsSpeaker && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.count > 2 && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.members[resp.userId]) {
                __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('showsSpeaker', {
                  isTalking: resp.talking,
                  userId: resp.userId === __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.userInfo.id ? 'local' : resp.userId
                });
              }
            } else if (resp.action === 'slowLink') {
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('networkCondition', {
                isGood: !resp.status,
                userId: resp.userId
              });
            }
            return _context.abrupt('break', 110);

          case 95:
            __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('video', {
              type: 'set',
              id: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.type === 'p2p' ? 'remote' : resp.userId,
              name: resp.name
            });
            return _context.abrupt('break', 110);

          case 97:
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.members[resp.userId].AUDIO = resp.status;
            __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('video', {
              type: 'set',
              id: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.type === 'p2p' ? 'remote' : resp.userId,
              isOffMic: resp.status
            });
            return _context.abrupt('break', 110);

          case 100:
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.members[resp.userId].VIDEO = resp.status;

            if (!(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.type === 'p2p')) {
              _context.next = 104;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('video', {
              type: 'set',
              id: 'remote',
              isOffVideo: resp.status
            });
            return _context.abrupt('return');

          case 104:

            //상태 관리
            if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus[resp.userId] && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus[resp.userId].audioSafe) {
              audioSafeStatus[resp.userId] = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus[resp.userId].audioSafe;
            } else {
              audioSafeStatus[resp.userId] = false;
            }
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setVideoStatus', { userId: resp.userId, cam: !resp.status, audioSafe: audioSafeStatus[resp.userId] });

            if (!audioSafeStatus[resp.userId]) {
              __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('video', {
                type: 'set',
                id: resp.userId,
                isOffVideo: resp.status
              });
            }

            return _context.abrupt('break', 110);

          case 108:
            __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('video', {
              type: 'set',
              id: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.roomInfo.type === 'p2p' ? 'remote' : resp.userId,
              isTalking: resp.status
            });
            return _context.abrupt('break', 110);

          case 110:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function onMessage(_x) {
    return _ref.apply(this, arguments);
  };
}();

function receiveRoomJoin(resp) {
  if (resp.code === '400') {
    return __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup-enter', {
      on: true,
      type: 'Alert',
      title: '회의 참여',
      contents: '회의 방이 만료되었습니다. 초기 화면으로 이동합니다.',
      cancel: function cancel() {
        window.location.href = '/';
      }
    });
    // 210202 mz, 16인 제한, 444 error 적용
  } else if (resp.code === '444') {
    return __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('popup-enter', {
      on: true,
      type: 'Alert',
      title: '회의 참여',
      contents: '회의 방의 인원이 초과되어 입장할 수 없습니다.',
      cancel: function cancel() {
        window.location.href = '/';
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setUserInfo', { id: resp.userId, name: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.userInfo.name ? __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.userInfo.name : '익명' });
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setResolution', resp.resolution);
  if (resp.members) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setRoomInfo', {
      members: resp.members,
      roomId: resp.roomId,
      count: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(resp.members).length,
      type: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(resp.members).length > 2 ? 'multi' : 'p2p'
    });
    //210202 mz, videoOnMembers 위치 변경 (RoomJoin, StartSession, Presence Op --> Peer connected)
    // let members = Object.keys(resp.members);
    // if(members.length>1){
    //   members.splice(members.indexOf(resp.userId),1);
    //   members.splice(0,0, resp.userId);
    //   store.commit('setVideoOnMembers', members);
    // }
  }
  __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace({ path: (resp.cp ? '/' + resp.cp : '') + '/room/' + resp.roomId });
}

function sendMessage(op) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'eventOp';

  var obj = {};
  obj[type] = op;
  if (op !== 'KeepAlive') {
    obj['cpCode'] = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].privateMode.cpCode[__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].env];
    obj['authKey'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoi64Kg66as7KeA7Y-s7J247Yq4IiwibWF4VXNlciI6IjUwMDAwMDAwIiwic3RhcnREYXRlIjoiMjAyMC0wMS0wMVQwNjo0NzowMC4wMDBaIiwiZW5kRGF0ZSI6IjIwMzAtMTItMzFUMDY6NDc6MDAuMDAwWiIsImF1dGhDb2RlIjoiS1AtMjAyMDAxMDEtMDEiLCJjb21wYW55Q29kZSI6IkxJQy0wMSIsImlhdCI6MTU4NzUzODExNH0.73A0UiiMHJeIS8pIgoN4DfEWT4QCsMnXkO4uUdnfbYI';
  }
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, obj);
  console.debug('[ ' + op + ' ] Web -> Signal ', data);
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.socket.emit('knowledgetalk', data);
}

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__webrtc__ = __webpack_require__(19);





var Mobile = function () {
  // Web Browser로 서비스 진행 시 true
  // Mobile 버전인지 확인
  function Mobile() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Mobile);

    this.isMobile = false;
    this.isWebView = false;
    this.isPlayBrowser = false;
    this.isSafari = false;
    this.isNotSupported = false;

    // 200622 ivypark, v1.0.0a mobile web view / web browser 구분 (deeplink 추가)
    this.isMobile = navigator.userAgent.match(/iPhone|iPod|iPad|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || navigator.userAgent.match(/LG|SAMSUNG|Samsung/) != null;
    this.isWebView = /KP_CCC_Android/i.test(navigator.userAgent);
    this.isSafari = /iPhone|iPod|iPad/i.test(navigator.userAgent);
    this.isNotSupported = /KAKAOTALK/i.test(navigator.userAgent);

    // console.debug(`----- device: ${this.isMobile ? 'Android' : 'Web'} // Web View : ${this.isWebView} // ${this.isSafari} -----`);
  } // App의 Web view 형태로 open 시


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Mobile, [{
    key: "onStartConference",
    value: function onStartConference(roomId) {
      console.log('mobile - onStartConference', roomId);
      window.kpCCC_Android.onStartConference(roomId);
    }

    // 210218 add entrance page

  }, {
    key: "mobileBackBtn",
    value: function mobileBackBtn() {
      __WEBPACK_IMPORTED_MODULE_2__eventBus__["a" /* eBus */].$emit('mobilebackbtn', {});
    }

    // 200622 ivypark, v0.9.4. mobile 코드 추가 (back 버튼, 방 나가기 이벤트)

  }, {
    key: "showExitPopup",
    value: function showExitPopup() {
      console.log('mobile - showExitPopup');
      __WEBPACK_IMPORTED_MODULE_2__eventBus__["a" /* eBus */].$emit('popup', {
        on: true,
        type: 'Confirm',
        title: '통화 종료',
        contents: "\uD1B5\uD654\uB97C \uC885\uB8CC \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
        ok: function ok() {
          __WEBPACK_IMPORTED_MODULE_3__webrtc__["a" /* default */].clear();
          __WEBPACK_IMPORTED_MODULE_2__eventBus__["a" /* eBus */].$emit('video', {
            type: 'remove'
          });
          window.location.href = '/';
        }
      });
    }

    // 200622 ivypark, v0.9.4. mobile 코드 추가 (back 버튼, 방 나가기 이벤트)

  }, {
    key: "exitRoom",
    value: function exitRoom() {
      __WEBPACK_IMPORTED_MODULE_3__webrtc__["a" /* default */].clear();
      __WEBPACK_IMPORTED_MODULE_2__eventBus__["a" /* eBus */].$emit('video', {
        type: 'remove'
      });
      window.location.href = '/';
    }
  }, {
    key: "setPlayBrowser",
    value: function setPlayBrowser(status) {
      this.isPlayBrowser = status;
    }
  }]);

  return Mobile;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Mobile());

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(9);










// import getStats from "../lib/getStats";

var WebRTC = function () {
  function WebRTC() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WebRTC);

    this.constraints = { video: { width: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].constraints.p2p.width, height: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].constraints.p2p.height, frameRate: { ideal: 20, max: 20 } }, audio: true };
    this.isNetworkChecking = false;
  }
  // constraints = { video: true, audio: true };


  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WebRTC, [{
    key: 'createVideoStream',
    value: function createVideoStream() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
          var stream;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return navigator.mediaDevices.getUserMedia(_this.constraints);

                case 3:
                  stream = _context.sent;

                  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setStreamInfo', { local: stream });
                  resolve(stream);
                  _context.next = 11;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context['catch'](0);
                  return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('popup', {
                    on: true,
                    type: 'Alert',
                    title: '영상 통화',
                    contents: '카메라, 마이크 장치를 불러오는 중 오류가 발생하였습니다.\n카메라, 마이크 권한 설정을 확인해주세요.',
                    cancel: function cancel() {
                      window.location.href = '/';
                    }
                  }));

                case 11:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[0, 8]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'createPeer',
    value: function createPeer(uid, isMulti, pluginId, host) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var peer, peerObj, s, id, peerCount;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  peer = new RTCPeerConnection(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].iceServer[__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].env][isMulti ? 'media' : 'p2p']);
                  // 200825 ivypark, legacy codes
                  // peer.onaddstream = ({ stream }) => {

                  peer.ontrack = function (_ref3) {
                    var streams = _ref3.streams;

                    console.debug('onaddstream :', streams[0]);

                    // 200825 ivypark,
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.streamInfo).some(function (elem) {
                      return elem === (uid === 'local' && !isMulti ? 'remote' : uid);
                    })) {
                      return false;
                    }

                    var streamObj = {};
                    streamObj[uid === 'local' && !isMulti ? 'remote' : uid] = streams[0];
                    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setStreamInfo', streamObj);

                    var info = {};
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members).length > 2) {
                      if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[uid]) {
                        info.name = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[uid].NAME;
                        info.isOffVideo = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[uid].VIDEO;
                        info.isOffMic = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[uid].AUDIO;
                        info.isBgBlur = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[uid].ISBLUR;
                        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoStatus', { userId: uid, cam: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[uid].VIDEO ? false : true, audioSafe: false });
                      }
                    } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members).length === 2) {
                      var remoteId = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members).filter(function (c) {
                        return c !== __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.userInfo.id;
                      })[0];
                      info.name = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[remoteId].NAME;
                      info.isOffVideo = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[remoteId].VIDEO;
                      info.isOffMic = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[remoteId].AUDIO;
                      info.isBgBlur = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[remoteId].ISBLUR;
                      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoStatus', { userId: uid, cam: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members[remoteId].VIDEO ? false : true, audioSafe: false });
                    }

                    __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('video', {
                      type: 'add',
                      isLocal: false,
                      id: uid === 'local' && !isMulti ? 'remote' : uid,
                      stream: streams[0],
                      count: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.count,
                      info: info
                    });
                  };

                  peerObj = {};

                  peerObj[uid] = peer;
                  peerObj[uid]['type'] = isMulti ? 'Y' : 'N';
                  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setPeerInfo', peerObj);
                  s = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state;
                  id = uid === 'local' ? 'local' : uid;
                  // let networkCondition = true;
                  // let localVideoStatus = true;

                  s.streamInfo.local.getTracks().forEach(function (track) {
                    return s.peerInfo[id].addTrack(track, s.streamInfo.local);
                  });

                  peer.onconnectionstatechange = function (e) {
                    console.debug('## ' + uid + ' onconnectionstatechange ## ', e.currentTarget.connectionState);
                    var state = e.currentTarget.connectionState;
                    if (s.peerInfo[uid] && (state === 'disconnected' || state === 'failed' || state === 'closed')) {
                      // 210208 PeerConnection error reload 제거
                      console.error('PeerConnection Error! ' + uid + ':' + state);
                      // // 210202 mz, 다자에서 publisher, subscriber peer 끊어질경우 reload
                      // if (isMulti) {
                      //   return eBus.$emit('popup', {
                      //     on: true,
                      //     type: 'Alert',
                      //     title: '영상 통화',
                      //     contents: '현재 사용 중인 기기의 네트워크 및 기기 상태가 좋지 않아 영상 송출이 중단 되었습니다. \n확인 버튼을 누르시면 현재 방에 재 접속 됩니다.',
                      //     cancel: () => {
                      //       window.location.reload(true);
                      //     }
                      //   });
                      // }
                      // eBus.$emit('video', {
                      //   type: 'remove',
                      //   count: store.state.roomInfo.count,
                      //   id: store.state.roomInfo.type === 'p2p' ? 'remote' : uid
                      // })
                    }
                    //210202 mz, videoOnMembers 위치 변경 (RoomJoin, StartSession, Presence Op --> Peer connected)
                    if (s.peerInfo[uid] && uid !== 'local' && isMulti && state === 'connected') {
                      var members = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members;
                      if (members) {
                        var videoOnMembers = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOnMembers;
                        var memberOnIdx = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.members).indexOf(uid);
                        if (memberOnIdx > -1) {
                          videoOnMembers.push(uid);
                          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoOnMembers', videoOnMembers);
                        }
                      }
                    }
                    //210202 mz, peer disconnect 로 상태 변경시 videoOnMembers videoOffMembers 제거하는 부분 추가
                    if (s.peerInfo[uid] && uid !== 'local' && isMulti && state === 'disconnected') {
                      var _videoOnMembers = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOnMembers;
                      var videoOffMembers = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOffMembers;
                      var videoOnIdx = _videoOnMembers.indexOf(uid);
                      var videoOffIdx = videoOffMembers.indexOf(uid);
                      if (videoOnIdx > -1) {
                        _videoOnMembers.splice(videoOnIdx, 1);
                        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoOnMembers', _videoOnMembers);
                      }
                      if (videoOffIdx > -1) {
                        videoOffMembers.splice(videoOffIdx, 1);
                        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoOffMembers', videoOffMembers);
                      }
                    }
                    if (uid === 'local' && isMulti && state === 'connected') {
                      console.log("network check start!", _this2.isNetworkChecking);
                      var localPeer = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo['local'];

                      if (!cocolib.audioSafe.status && !_this2.isNetworkChecking) {
                        cocolib.audioSafe.start(localPeer, __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.count);
                        _this2.isNetworkChecking = true;
                        console.debug("add event listener only once");
                        // add event listener only once

                        var _videoOnMembers2 = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOnMembers;
                        var _videoOffMembers = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOffMembers;

                        // 네트워크 상태가 좋아질 때
                        window.addEventListener('onaudiosafegd', function () {
                          console.debug("good!!!");

                          _videoOnMembers2 = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOnMembers;
                          _videoOffMembers = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOffMembers;

                          //210202 mz, videOnMembers local id 없어서 걸리는 숫자 변경
                          if (_videoOffMembers.length > 0) {
                            var survivor = _videoOffMembers.shift();
                            _videoOnMembers2.push(survivor);
                            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoOnMembers', _videoOnMembers2);
                            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoOffMembers', _videoOffMembers);

                            console.log(survivor + ' -> video on!');
                            _this2.remoteVideoControl(true, survivor);
                          }
                        });

                        // 네트워크 상태가 나빠질 때
                        window.addEventListener('onaudiosafebd', function () {
                          console.debug("bad!!!");

                          _videoOnMembers2 = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOnMembers;
                          _videoOffMembers = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoOffMembers;

                          //210202 mz, videOnMembers local id 없어서 걸리는 숫자 변경
                          if (_videoOnMembers2.length > 0) {
                            var victim = _videoOnMembers2.shift();
                            _videoOffMembers.push(victim);
                            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoOnMembers', _videoOnMembers2);
                            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoOffMembers', _videoOffMembers);

                            console.log(victim + ' -> video off!');
                            _this2.remoteVideoControl(false, victim);
                          }
                        });

                        // 네트워크 상태가 좋지도 나쁘지도 않을 때
                        window.addEventListener('onaudiosafenbd', function () {
                          console.debug("Not bad!!!");
                        });
                      }
                    }
                  };
                  peer.onicegatheringstatechange = function (e) {
                    // 200703 ivypark, v1.0.2. gatheringstate -> candidate null 일때 SDP 전송으로 변경
                    // console.debug(`## ${uid} iceGatheringState ## `, peer.iceGatheringState);
                    // if (peer.iceGatheringState === 'complete') {
                    //   sendMessage('SDP', { sdp: peer.localDescription, usage: 'cam', roomId: store.state.roomInfo.roomId, isSfu: true, userId: store.state.userInfo.id });
                    // }
                  };

                  peerCount = 0;

                  peer.onicecandidate = function (e) {
                    if (peerCount <= 0) {
                      setTimeout(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_8__message__["b" /* sendMessage */])('SDP', { sdp: peer.localDescription, usage: 'cam', roomId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.roomId, isSfu: true, userId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.userInfo.id, pluginId: pluginId, host: host, useMediaSvr: isMulti ? 'Y' : 'N' });
                        if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.host === true) __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setRoomInfo', { host: false });
                      }, 1500);
                    }
                    peerCount++;
                    // if (!e.candidate) {
                    // peerCount++;
                    // sendMessage('SDP', { sdp: peer.localDescription, usage: 'cam', roomId: store.state.roomInfo.roomId, isSfu: true, userId: store.state.userInfo.id, pluginId: pluginId, host: store.state.roomInfo.host });
                    // if (store.state.roomInfo.host === true) store.commit('setRoomInfo', { host: false });
                    // sendMessage('Candidate', { candidate: e.candidate, usage: 'cam', roomId: store.state.roomInfo.roomId, isSfu: true, userId: store.state.userInfo.id });
                    // }
                  };
                  resolve();

                case 14:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'createOffer',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(uid) {
        var offer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo[uid].createOffer();

              case 3:
                offer = _context3.sent;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo[uid].setLocalDescription(offer);

              case 6:
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function createOffer(_x5) {
        return _ref4.apply(this, arguments);
      }

      return createOffer;
    }()
  }, {
    key: 'createAnswer',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(sdp, uid) {
        var answer;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo[uid].setRemoteDescription(sdp);

              case 3:
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo[uid].createAnswer();

              case 5:
                answer = _context4.sent;
                _context4.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo[uid].setLocalDescription(answer);

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function createAnswer(_x6, _x7) {
        return _ref5.apply(this, arguments);
      }

      return createAnswer;
    }()
  }, {
    key: 'setRemoteDescription',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(sdp, uid) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo[uid].setRemoteDescription(sdp);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setRemoteDescription(_x8, _x9) {
        return _ref6.apply(this, arguments);
      }

      return setRemoteDescription;
    }()
  }, {
    key: 'setCandidate',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(candidate, uid) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo[uid].addIceCandidate(new RTCIceCandidate(candidate));

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setCandidate(_x10, _x11) {
        return _ref7.apply(this, arguments);
      }

      return setCandidate;
    }()
  }, {
    key: 'checkMediaDevices',
    value: function checkMediaDevices() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        navigator.mediaDevices.enumerateDevices().then(function (devices) {
          // console.debug('enumerateDevices : ', devices);
          var cam = devices.some(function (elem) {
            return elem.kind === 'videoinput';
          });
          var mic = devices.some(function (elem) {
            return elem.kind === 'audioinput';
          });

          _this3.constraints.video = cam ? _this3.constraints.video : false;
          _this3.constraints.audio = mic ? _this3.constraints.audio : false;

          if (cam && mic) {
            resolve(true);
          } else {
            __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('popup', {
              on: true,
              type: 'Confirm',
              title: '통화 방 입장 오류',
              contents: (!cam && !mic ? '카메라, 마이크' : !cam ? '카메라' : '마이크') + ' \uC7A5\uCE58\uAC00 \uC778\uC2DD\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\n\uD68C\uC758\uC2E4\uC5D0 \uC785\uC7A5 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
              ok: function ok() {
                // eBus.$emit('popup', { on: false });
                resolve(true);
              },
              cancel: function cancel() {
                resolve(false);
              }
            });
          }
        }).catch(function (e) {
          console.error('## devices are not found: ', e);
          __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('popup', {
            on: true,
            type: 'Confirm',
            title: '통화 방 입장 오류',
            contents: '\uCE74\uBA54\uB77C, \uB9C8\uC774\uD06C \uC7A5\uCE58\uAC00 \uC778\uC2DD\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\n\uD68C\uC758\uC2E4\uC5D0 \uC785\uC7A5 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
            ok: function ok() {
              // eBus.$emit('popup', { on: false });
              resolve(true);
            },
            cancel: function cancel() {
              resolve(false);
            }
          });
        });
      });
    }
  }, {
    key: 'setConstraint',
    value: function setConstraint(constraints) {
      var _this4 = this;

      var s = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.streamInfo;
      if (s.local) {
        var tracks = s.local.getTracks();
        tracks.forEach(function () {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(curr) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!(curr.kind === 'video')) {
                      _context7.next = 4;
                      break;
                    }

                    _context7.next = 3;
                    return curr.applyConstraints(constraints);

                  case 3:
                    console.debug('getConstraints ----------> ', curr.getConstraints());

                  case 4:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee7, _this4);
          }));

          return function (_x12) {
            return _ref8.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: 'destroyRoom',
    value: function destroyRoom() {
      Object(__WEBPACK_IMPORTED_MODULE_8__message__["b" /* sendMessage */])('DestroyRoom', { roomId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.roomId });
    }
  }, {
    key: 'clear',
    value: function clear() {
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('clearAll');
    }
  }, {
    key: 'remoteVideoControl',
    value: function remoteVideoControl(flag, who) {
      Object(__WEBPACK_IMPORTED_MODULE_8__message__["b" /* sendMessage */])('EditFeed', {
        roomId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.roomId,
        userId: who,
        video: flag
      }, 'eventOp');
    }
  }, {
    key: 'handlingLocalCamera',
    value: function handlingLocalCamera(flag) {
      // console.log("dongwook ::: ", Buttons.data().isOffVideo);
      // Buttons.data().isOffVideo = !Buttons.data().isOffVideo;

      var s = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state;

      if (s.streamInfo.local) {
        var tracks = s.streamInfo.local.getTracks();
        tracks.forEach(function (curr) {
          if (curr.kind === 'video') {
            curr.enabled = flag;
          }
        });
      }
    }
  }]);

  return WebRTC;
}();

/* harmony default export */ __webpack_exports__["a"] = (new WebRTC());

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Main_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Call_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Entrance_vue__ = __webpack_require__(234);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__views_Main_vue__["a" /* default */] }, { path: '/:cp/', component: __WEBPACK_IMPORTED_MODULE_2__views_Main_vue__["a" /* default */] }, { path: '/entrance/:id', component: __WEBPACK_IMPORTED_MODULE_4__views_Entrance_vue__["a" /* default */] }, { path: '/:cp/entrance/:id', component: __WEBPACK_IMPORTED_MODULE_3__views_Call_vue__["a" /* default */] }, { path: '/room/:id', component: __WEBPACK_IMPORTED_MODULE_3__views_Call_vue__["a" /* default */] }, { path: '/:cp/room/:id', component: __WEBPACK_IMPORTED_MODULE_3__views_Call_vue__["a" /* default */] }]
}));

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(9);





var Utils = function () {
  function Utils() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Utils);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Utils, [{
    key: 'getPrivateUrl',
    value: function getPrivateUrl() {
      return '/' + (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.userInfo.cp ? __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.userInfo.cp : '');
    }
  }, {
    key: 'setPrivateInfo',
    value: function setPrivateInfo(cp, ip) {
      if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].privateMode.switch) {
        var payload = { cp: cp };
        if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].privateMode.cpName !== cp) {
          // TODO: 200810 ivypark, 설정된 CP이름과 다를 경우 에러페이지 출력
          console.warn('settings is incorrect.');
        }

        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setUserInfo', payload);
      }
    }
  }, {
    key: 'getPacketsTimeline',
    value: function getPacketsTimeline(data) {}
  }]);

  return Utils;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Utils());

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77541a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__ = __webpack_require__(208);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77541a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_session__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Popup__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppModal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_mobile__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commons_eventBus__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Popup: __WEBPACK_IMPORTED_MODULE_5__components_Popup__["a" /* default */], AppModal: __WEBPACK_IMPORTED_MODULE_6__components_AppModal__["a" /* default */] },
  data: function data() {
    return {
      url: '',
      highResolution: true,
      isCollapsedJoinBtn: false,
      popup: {
        on: false,
        type: '',
        title: '',
        contents: '',
        option: {},
        ok: null,
        cancel: null
      },
      toast: '',
      appModal: false,
      isFaqOpen: false,
      isWebview: __WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isMobile && __WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isWebView
    };
  },
  mounted: function mounted() {
    var _this = this;

    // 210219 data reset 추가
    if (this.$store.state.socket) this.$store.state.socket.disconnect();

    // 200826 ivypark, v1.1.1. 모바일 웹브라우저 동작 팝업 추가
    // 200721 ivypark, v1.0.8. 메인페이지 deeplink 추가 - v1.1.1-rc4: kakaotalk 브라우저 이슈로 재 추가
    if (__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isMobile && __WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isNotSupported) {
      this.appModal = true;
      if (!__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isSafari) {
        //210218 add Entrance page 
        var roomId = window.location.href.indexOf('/room/') > -1 ? window.location.href.split('/room/')[1] : window.location.href.indexOf('/entrance/') > -1 ? window.location.href.split('/entrance/')[1] : '';
        location.href = 'Intent://kp.cococall' + (roomId !== '' ? '?roomid=' + roomId : '') + '#Intent;scheme=kpoint;package=kr.co.knowledgepoint.knowledgetalkccc;end';
        return false;
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isMobile && !__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isWebView) {
      this.appModal = true;
    }

    // 200812 ivypark, v1.1.0a. 영문화 적용. initialize
    this.$i18n.locale = (__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isMobile ? this.$store.state.language : window.localStorage.getItem('locale')) || 'ko';
    this.$store.commit('setLanguage', this.$i18n.locale);

    __WEBPACK_IMPORTED_MODULE_10__commons_eventBus__["a" /* eBus */].$on('popup-main', function (param) {
      _this.popup.on = param.on;
      _this.popup.type = param.type;
      _this.popup.title = param.title;
      _this.popup.contents = param.contents;
      _this.popup.option = param.option;
      _this.popup.ok = param.ok;
      _this.popup.cancel = param.cancel;
    });

    // 200810 ivypark, v1.1.0b. 비즈니스 버전 (ip, cp 체크)
    __WEBPACK_IMPORTED_MODULE_9__commons_utils__["a" /* default */].setPrivateInfo(this.$route.params.cp);
  },

  methods: {
    handleMakeBtnClick: function handleMakeBtnClick() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var session;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                session = new __WEBPACK_IMPORTED_MODULE_2__commons_session__["a" /* default */]();
                _context.next = 3;
                return session.connect();

              case 3:
                if (!_context.sent) {
                  _context.next = 7;
                  break;
                }

                // 210202 mz, 16인 제한
                Object(__WEBPACK_IMPORTED_MODULE_3__commons_message__["b" /* sendMessage */])('CreateRoom', { cp: _this2.$route.params.cp, capacity: 16, resolution: _this2.highResolution ? 'high' : 'low' });
                _context.next = 9;
                break;

              case 7:
                session.close();
                _this2.onPopup('서버와의 연결이 원활하지 않습니다. 잠시 후 다시 시도해주세요.');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleMouseoverJoinBtn: function handleMouseoverJoinBtn() {
      if (!__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isMobile && !this.isCollapsedJoinBtn) {
        this.isCollapsedJoinBtn = !this.isCollapsedJoinBtn;
        return false;
      }
    },
    handleJoinBtnClick: function handleJoinBtnClick() {
      if (__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isMobile && !this.isCollapsedJoinBtn) {
        this.isCollapsedJoinBtn = !this.isCollapsedJoinBtn;
        return false;
      }

      // 200709 ivypark, v1.0.5. 회의 참여 버튼 추가
      if (!this.url) {
        this.onPopup(this.$t('popup-join-failed-contents-1'));
        return false;
      } else {
        var addUrl = '';
        if (this.$store.state.userInfo.cp) addUrl = '/' + this.$store.state.userInfo.cp;

        if (this.url.indexOf('https://') === 0 && (this.url.indexOf('/room/') > -1 || this.url.indexOf('/entrance/') > -1)) {
          // URL을 입력 한 경우

          // 200813 ivypark, v1.1.0b. 라이센스 버전 url 변경으로 인해 url 체크 부분 변경
          var urlArr = this.url.split('/');
          var domain = urlArr[2];
          var roomId = this.url.indexOf('/room/') > -1 ? urlArr[urlArr.findIndex(function (elem) {
            return elem === 'room';
          }) + 1] : this.url.indexOf('/entrance/') > -1 ? urlArr[urlArr.findIndex(function (elem) {
            return elem === 'entrance';
          }) + 1] : '';
          if (__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].listOfDomains.some(function (c) {
            return domain.indexOf(c) > -1;
          }) && Number(roomId) && roomId.length === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].lengthOfRoomId) {
            __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push({ path: addUrl + '/entrance/' + roomId });
          } else {
            this.onPopup(this.$t('popup-join-failed-contents-2'));
          }
        } else {
          // Room 번호만 입력 한 경우
          if (Number(this.url) && this.url.length === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].lengthOfRoomId) {
            __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push({ path: addUrl + '/entrance/' + this.url });
          } else {
            this.onPopup(this.$t('popup-join-failed-contents-2'));
          }
        }
      }
    },
    onPopup: function onPopup(contents) {
      this.popup.on = true;
      this.popup.type = 'Alert';
      this.popup.title = this.$t('popup-join-failed-title');
      this.popup.contents = contents;
    },
    handlePopupOkBtnClick: function handlePopupOkBtnClick(param) {
      this.popup.on = false;
      if (this.popup.ok) this.popup.ok(param);
    },
    handlePopupCancelBtnClick: function handlePopupCancelBtnClick(param) {
      this.popup.on = false;
      if (this.popup.cancel) this.popup.cancel(param);
    },
    handleAppModalClose: function handleAppModalClose() {
      this.appModal = false;
    },
    handleFaqBtnClick: function handleFaqBtnClick() {
      this.$refs.answer.style.display = !this.$refs.answer.style.display || this.$refs.answer.style.display === 'none' ? 'block' : 'none';
      this.isFaqOpen = this.$refs.answer.style.display === 'block';
    },
    onChangeLanguage: function onChangeLanguage() {
      this.$i18n.locale = this.$i18n.locale === 'ko' ? 'en' : 'ko';
      if (!__WEBPACK_IMPORTED_MODULE_7__commons_mobile__["a" /* default */].isMobile) window.localStorage.setItem('locale', this.$i18n.locale);
      this.$store.commit('setLanguage', this.$i18n.locale);
      // return this.$i18n.locale;
    },
    changeDeveloperMode: function changeDeveloperMode() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].developerMode = !__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].developerMode;
      console.log('developer mode : ', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].developerMode);
      clearTimeout(this.timeout);
      this.toast = 'developer mode ' + (__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].developerMode ? 'on' : 'off');
      this.timeout = setTimeout(function () {
        _this3.toast = '';
      }, 1500);
    }
  },
  computed: {
    getVersion: function getVersion() {
      return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].version;
    }
  }
});

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__webrtc__ = __webpack_require__(19);











var Session = function () {
  function Session() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Session);

    this.socket = null;
    this.timeout = null;
    this.interval = null;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Session, [{
    key: 'connect',
    value: function connect() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        console.debug('----------------- Opened Session -----------------');
        _this.socket = __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default.a.connect(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].socketIoUrl[__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].env], { reconnect: true, 'transports': ['websocket'] });

        _this.socket.on('connect', function () {
          _this.socket.on('knowledgetalk', __WEBPACK_IMPORTED_MODULE_6__message__["a" /* onMessage */]);
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setSocketIo', _this.socket);

          if (!_this.interval) {
            Object(__WEBPACK_IMPORTED_MODULE_6__message__["b" /* sendMessage */])('KeepAlive', {});
            _this.interval = setInterval(_this.handleIntervalProc, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].pingInterval * 1000);
          }

          resolve(true);
        });

        _this.socket.on('disconnect', function () {
          _this.stopInterval();
          __WEBPACK_IMPORTED_MODULE_9__webrtc__["a" /* default */].clear();
          __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('video', { type: 'remove' });
          __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('popup', {
            on: true,
            type: 'Alert',
            title: '회의 참여',
            contents: '서버와의 연결이 원활하지 않아 초기화면으로 이동합니다.',
            cancel: function cancel() {
              window.location.href = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].getPrivateUrl();
            }
          });
          resolve(false);
        });

        _this.socket.on('connect_error', function () {
          _this.stopInterval();
          __WEBPACK_IMPORTED_MODULE_9__webrtc__["a" /* default */].clear();
          __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('video', { type: 'remove' });
          __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* eBus */].$emit('popup', {
            on: true,
            type: 'Alert',
            title: '회의 참여',
            contents: '서버와의 연결이 원활하지 않아 초기화면으로 이동합니다.',
            cancel: function cancel() {
              window.location.href = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].getPrivateUrl();
            }
          });
          resolve(false);
        });
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.socket.close();
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('clearAll');
      this.stopInterval();
    }
  }, {
    key: 'handleIntervalProc',
    value: function handleIntervalProc() {
      Object(__WEBPACK_IMPORTED_MODULE_6__message__["b" /* sendMessage */])('KeepAlive', {});
    }
  }, {
    key: 'stopInterval',
    value: function stopInterval() {
      if (this.interval) clearInterval(this.interval);
    }
  }]);

  return Session;
}();

/* harmony default export */ __webpack_exports__["a"] = (Session);

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popupElements_ChangeName__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popupElements_Confirm__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popupElements_Invite__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popupElements_Alert__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popupElements_Settings__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__popupElements_Join__ = __webpack_require__(206);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: { type: String, title: String, contents: String, ok: Function, cancel: Function, option: Object },
  components: { ChangeName: __WEBPACK_IMPORTED_MODULE_0__popupElements_ChangeName__["a" /* default */], Confirm: __WEBPACK_IMPORTED_MODULE_1__popupElements_Confirm__["a" /* default */], Invite: __WEBPACK_IMPORTED_MODULE_2__popupElements_Invite__["a" /* default */], Alert: __WEBPACK_IMPORTED_MODULE_3__popupElements_Alert__["a" /* default */], Settings: __WEBPACK_IMPORTED_MODULE_4__popupElements_Settings__["a" /* default */], Join: __WEBPACK_IMPORTED_MODULE_5__popupElements_Join__["a" /* default */] },
  data: function data() {
    return {
      contentsType: this.type,
      pTitle: this.title,
      pContents: this.contents,
      okBtnClick: this.ok,
      cancelBtnClick: this.cancel,
      timeout: null
    };
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_message__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: { ok: Function, cancel: Function, option: Object },
  data: function data() {
    return {
      name: this.$store.state.userInfo.name
    };
  },

  methods: {
    confirmed: function confirmed() {
      if (!this.name) {
        __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', this.$t('popup-change-name-contents'));
        return;
      }
      this.$store.commit('setUserInfo', { name: this.name });
      this.ok({ id: this.$store.state.userInfo.id, name: this.name });
      __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', this.$t('popup-change-name-complete'));
      Object(__WEBPACK_IMPORTED_MODULE_1__commons_message__["b" /* sendMessage */])('ChangeName', { userId: this.$store.state.userInfo.id, roomId: this.$store.state.roomInfo.roomId, name: this.name }, 'signalOp');
    }
  },
  mounted: function mounted() {
    this.$refs.nameInput.select();
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { contents: String, ok: Function, cancel: Function }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    handleUrlCopyBtnClick: function handleUrlCopyBtnClick() {
      var t = document.createElement("textarea");
      document.body.appendChild(t);
      t.value = window.location.href + '\n\n\uC548\uB4DC\uB85C\uC774\uB4DC\uB294 \uD06C\uB86C \uBE0C\uB77C\uC6B0\uC800, \uC544\uC774\uD3F0\uC740 \uC0AC\uD30C\uB9AC \uBE0C\uB77C\uC6B0\uC800\uC5D0 \uBCF8 URL\uC744 \uBCF5\uC0AC\uD558\uC5EC \uBD99\uC5EC \uB123\uC73C\uC2DC\uBA74 \uD68C\uC758 \uBC29\uC5D0 \uCC38\uC11D\uD558\uC2E4\uC218 \uC788\uC2B5\uB2C8\uB2E4.\n\uC571\uC774 \uC788\uB294 \uACBD\uC6B0 \uC704 URL\uC744 \uD074\uB9AD\uD558\uC2DC\uBA74 \uC571\uC73C\uB85C \uC774\uB3D9 \uB418\uBA70, \uC790\uB3D9\uC73C\uB85C \uD68C\uC758 \uBC29\uC5D0 \uCC38\uC11D\uD569\uB2C8\uB2E4.';
      t.select();
      document.execCommand('copy');
      document.body.removeChild(t);

      __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', this.$t('popup-invite-url-complete'));
      // 200702 ivypark, v1.0.1. 버튼 클릭 시 팝업 종료
      __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('popup', { on: false });
    },
    handleTalkBtnClick: function handleTalkBtnClick() {
      __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', this.$t('popup-invite-soon'));
    },
    handleSMSBtnClick: function handleSMSBtnClick() {
      __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', this.$t('popup-invite-soon'));
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { contents: String, cancel: Function }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: { contents: String, ok: Function, option: Object },
  data: function data() {
    return {
      // isChecked: false,
      isPlayTestMic: false,
      isPlayTestSound: false,
      outputDeviceId: '', // if you click sound test button.
      meter: null,
      volumeHeight: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    // local mic on
    // eBus.$emit('setVideo', {
    //   type: 'set',
    //   id: 'local',
    //   deviceSetting: {
    //     done: false
    //   }
    // });

    // 다시 보지 않기
    // this.isChecked = window.localStorage.getItem('IS_CHECKED_DEVICE') ? JSON.parse(window.localStorage.getItem('IS_CHECKED_DEVICE').toLowerCase()) : false;
    this.init();

    if (this.option && this.option.inCall) {
      var audioInput = this.$refs.audioInput;
      var videoInput = this.$refs.videoInput;
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.streamInfo.local.getTracks().forEach(function (curr) {
        var option = document.createElement("option");
        option.value = curr.id;
        option.text = curr.label;
        if (curr.kind === 'audio') audioInput.appendChild(option);
        if (curr.kind === 'video') videoInput.appendChild(option);
      });

      if (!this.$refs.audioOutput.hasChildNodes()) {
        navigator.mediaDevices.enumerateDevices().then(function (devices) {
          devices.forEach(function (curr) {
            if (curr.deviceId === 'default' && curr.kind === 'audiooutput') {
              var option = document.createElement("option");
              option.value = curr.id;
              option.text = curr.label;
              _this.$refs.audioOutput.appendChild(option);
            }
          });
        });
      }
    }
  },

  methods: {
    init: function init() {
      var _this2 = this;

      var audioInput = this.$refs.audioInput;
      var audioOutput = this.$refs.audioOutput;
      var videoInput = this.$refs.videoInput;
      this.outputDeviceId = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.userInfo.sinkId ? __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.userInfo.sinkId : '';

      while (audioInput.hasChildNodes()) {
        audioInput.removeChild(audioInput.firstChild);
      }while (audioOutput.hasChildNodes()) {
        audioOutput.removeChild(audioOutput.firstChild);
      }while (videoInput.hasChildNodes()) {
        videoInput.removeChild(videoInput.firstChild);
      }navigator.mediaDevices.enumerateDevices().then(function (devices) {
        for (var i = 0; i !== devices.length; ++i) {
          var deviceInfo = devices[i];
          var option = document.createElement("option");
          option.value = deviceInfo.deviceId;
          if (deviceInfo.kind === "audioinput") {
            option.text = deviceInfo.label || 'microphone ' + (audioInput.length + 1);
            if (!_this2.option.inCall) audioInput.appendChild(option);
          } else if (deviceInfo.kind === "audiooutput") {
            option.text = deviceInfo.label || 'speaker ' + (audioOutput.length + 1);
            if (!_this2.option.inCall || _this2.option.inCall && _this2.outputDeviceId === deviceInfo.deviceId) audioOutput.appendChild(option);
          } else if (deviceInfo.kind === "videoinput") {
            option.text = deviceInfo.label || 'camera ' + (videoInput.length + 1);
            if (!_this2.option.inCall) videoInput.appendChild(option);
          } else {
            console.log("Some other kind of source/device: ", deviceInfo);
          }

          if (i === devices.length - 1 && !_this2.option.inCall) {
            // 새로고침 시 default 데이터로 변경
            _this2.onChange();
            _this2.onChangeOutput();
          }
        }
      }).catch(function (e) {
        console.error(e);
      });
    },
    onChange: function onChange() {
      var _this3 = this;

      var audioInput = this.$refs.audioInput.value;
      var videoInput = this.$refs.videoInput.value;

      navigator.mediaDevices.getUserMedia({
        audio: audioInput ? { deviceId: { exact: audioInput } } : false,
        video: videoInput ? { deviceId: { exact: videoInput } } : false
      }).then(function (stream) {
        // 210219 localStream 변경 시 기존 stream track stop
        var localS = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.streamInfo['local'];
        var tracks = localS.getTracks();
        tracks.forEach(function (curr) {
          curr.stop();
        });

        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setStreamInfo', { local: stream });
        _this3.checkMic();

        var video = document.querySelector('video');
        video.srcObject = stream;
        video.autoplay = true;
        video.muted = true;
        video.playsInline = true;
      }).catch(function (err) {
        console.error(err);
      });
    },
    onChangeOutput: function onChangeOutput(e) {
      this.outputDeviceId = e ? e.target.value : 'default';
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setUserInfo', { sinkId: this.outputDeviceId });
      // eBus.$emit('video', {
      //   type: 'set',
      //   id: 'local',
      //   deviceSetting: {
      //     sinkId: this.outputDeviceId,
      //     done: false
      //   }
      // });
    },

    // onChangeCheckbox(e) {
    //   window.localStorage.setItem('IS_CHECKED_DEVICE', e.target.checked);
    //   this.isChecked = e.target.checked;
    // },
    handlePlayTestSound: function handlePlayTestSound() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var audio;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.isPlayTestSound) {
                  _context.next = 9;
                  break;
                }

                _this4.isPlayTestSound = true;
                audio = document.createElement('audio');
                _context.next = 5;
                return audio.setSinkId(_this4.outputDeviceId);

              case 5:
                audio.src = '/static/audio/harp_run_' + (Math.floor(Math.random() * 2) + 1) + '.wav';
                audio.onended = function () {
                  audio.remove();
                  _this4.isPlayTestSound = false;
                };
                _context.next = 9;
                return audio.play();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    checkMic: function checkMic() {
      var audioContext = new AudioContext();
      var mediaStreamSource = audioContext.createMediaStreamSource(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.streamInfo.local);
      this.meter = createAudioMeter(audioContext);
      mediaStreamSource.connect(this.meter);
      this.onLevelChange();

      function createAudioMeter(audioContext, clipLevel, averaging, clipLag) {
        var processor = audioContext.createScriptProcessor(512);
        processor.onaudioprocess = volumeAudioProcess;
        processor.clipping = false;
        processor.lastClip = 0;
        processor.volume = 0;
        processor.clipLevel = clipLevel || 0.98;
        processor.averaging = averaging || 0.95;
        processor.clipLag = clipLag || 750;

        // this will have no effect, since we don't copy the input to the output,
        // but works around a current Chrome bug.
        processor.connect(audioContext.destination);

        processor.checkClipping = function () {
          if (!this.clipping) return false;
          if (this.lastClip + this.clipLag < window.performance.now()) this.clipping = false;
          return this.clipping;
        };

        processor.shutdown = function () {
          this.disconnect();
          this.onaudioprocess = null;
        };

        return processor;
      }

      function volumeAudioProcess(event) {
        var buf = event.inputBuffer.getChannelData(0);
        var bufLength = buf.length;
        var sum = 0;
        var x;

        // Do a root-mean-square on the samples: sum up the squares...
        for (var i = 0; i < bufLength; i++) {
          x = buf[i];
          if (Math.abs(x) >= this.clipLevel) {
            this.clipping = true;
            this.lastClip = window.performance.now();
          }
          sum += x * x;
        }

        // ... then take the square root of the sum.
        var rms = Math.sqrt(sum / bufLength);

        // Now smooth this out with the averaging factor applied
        // to the previous sample - take the max here because we
        // want "fast attack, slow release."
        this.volume = Math.max(rms, this.volume * this.averaging);
      }
    },
    onLevelChange: function onLevelChange(time) {
      var volume = this.meter.volume * 100;
      this.isPlayTestMic = volume > 1;
      this.volumeHeight = 'height:' + volume * 2 + '%';
      // if (volume > 1) console.log(volume);

      // set up the next callback
      var rafID = window.requestAnimationFrame(this.onLevelChange);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_mobile__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_webrtc__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: { ok: Function, cancel: Function },
  data: function data() {
    return {
      url: ''
    };
  },

  methods: {
    confirmed: function confirmed() {
      var _this = this;

      // 200709 ivypark, v1.0.5. 회의 참여 버튼 추가
      if (!this.url) {
        __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', "\uCC38\uC5EC \uD558\uC2E4 URL \uB610\uB294 \uBC29 \uBC88\uD638(" + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].lengthOfRoomId + "\uC790\uB9AC)\uB97C \uC785\uB825\uD558\uC138\uC694.");
        return false;
      } else {
        if (this.url.indexOf('https://') === 0 && this.url.indexOf('/room/') > -1) {
          // URL을 입력 한 경우
          var domain = this.url.split('/')[2];
          var roomId = this.url.split('/')[4];
          if (__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].listOfDomains.some(function (c) {
            return domain.indexOf(c) > -1;
          }) && Number(roomId) && roomId.length === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].lengthOfRoomId) {
            __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', '잠시 후 다른 회의 방으로 이동합니다.');
            this.ok();

            setTimeout(function () {
              // webRTC.clear();
              if (__WEBPACK_IMPORTED_MODULE_2__commons_mobile__["a" /* default */].isMobile) {
                __WEBPACK_IMPORTED_MODULE_3__commons_webrtc__["a" /* default */].clear();
                __WEBPACK_IMPORTED_MODULE_2__commons_mobile__["a" /* default */].onStartConference(roomId);
              } else {
                window.location.href = "/room/" + roomId;
              }
            }, 1000);
          } else {
            __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', '전달 받은 URL 또는 번호를 정확히 입력해주세요.');
          }
        } else {
          // Room 번호만 입력 한 경우
          if (Number(this.url) && this.url.length === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].lengthOfRoomId) {
            __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', '잠시 후 다른 회의 방으로 이동합니다.');
            this.ok();

            setTimeout(function () {
              // webRTC.clear();
              if (__WEBPACK_IMPORTED_MODULE_2__commons_mobile__["a" /* default */].isMobile) {
                __WEBPACK_IMPORTED_MODULE_2__commons_mobile__["a" /* default */].onStartConference(_this.url);
              } else {
                window.location.href = "/room/" + _this.url;
              }
            }, 1000);
          } else {
            __WEBPACK_IMPORTED_MODULE_0__commons_eventBus__["a" /* eBus */].$emit('toast', '전달 받은 URL 또는 번호를 정확히 입력해주세요.');
          }
        }
      }
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppModal_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef28af7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppModal_vue__ = __webpack_require__(209);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef28af7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_mobile__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_eventBus__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: { close: Function },
  components: {},
  data: function data() {
    return {
      showUseMobile: !__WEBPACK_IMPORTED_MODULE_0__commons_mobile__["a" /* default */].isNotSupported
    };
  },

  methods: {
    handleClickAppBtn: function handleClickAppBtn() {
      var roomId = window.location.href.indexOf('/room/') > -1 ? window.location.href.split('/room/')[1] : window.location.href.indexOf('/entrance/') > -1 ? window.location.href.split('/entrance/')[1] : '';
      if (__WEBPACK_IMPORTED_MODULE_0__commons_mobile__["a" /* default */].isSafari) {
        //universal link
        location.href = "https://knowledgepoint.co.kr/ios_ulink/roomjoin" + (roomId !== '' ? "?roomid=" + roomId : "");
        __WEBPACK_IMPORTED_MODULE_0__commons_mobile__["a" /* default */].setPlayBrowser(false);
      } else {
        location.href = "Intent://kp.cococall" + (roomId !== '' ? "?roomid=" + roomId : "") + "#Intent;scheme=kpoint;package=kr.co.knowledgepoint.knowledgetalkccc;end";
        __WEBPACK_IMPORTED_MODULE_0__commons_mobile__["a" /* default */].setPlayBrowser(false);
      }
    },
    handleClickMobileWebBtn: function handleClickMobileWebBtn() {
      this.close();
      __WEBPACK_IMPORTED_MODULE_0__commons_mobile__["a" /* default */].setPlayBrowser(true);
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_webrtc__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_mobile__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Video__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_OffVideo__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Popup__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Buttons__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Video: __WEBPACK_IMPORTED_MODULE_9__components_Video__["a" /* default */], OffVideo: __WEBPACK_IMPORTED_MODULE_10__components_OffVideo__["a" /* default */], Buttons: __WEBPACK_IMPORTED_MODULE_12__components_Buttons__["a" /* default */], Popup: __WEBPACK_IMPORTED_MODULE_11__components_Popup__["a" /* default */] },
  data: function data() {
    return {
      videos: [],
      offVideos: [],
      videoDisplayType: 'one',
      share: null,
      visibleBtnArea: false,
      isCollapsedVideo: false,
      constraint: {
        width: { min: 128, ideal: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].constraints.p2p.width },
        height: { min: 72, ideal: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].constraints.p2p.height },
        frameRate: { ideal: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].constraints.p2p.frameRate },
        aspectRatio: 16 / 9.0
      },
      popup: {
        on: false,
        type: '',
        title: '',
        contents: '',
        option: {
          inCall: false
        },
        ok: null,
        cancel: null
      },
      toast: '',
      buttonInfo: {
        on: true,
        message: this.$t('call-menu-information-pc-1')
      },
      isBackground: false
    };
  },
  beforeCreate: function beforeCreate() {
    // 200812 ivypark, v1.1.0a. 영문화 적용. initialize
    this.$i18n.locale = (__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile ? this.$store.state.language : window.localStorage.getItem('locale')) || 'ko';
    this.$store.commit('setLanguage', this.$i18n.locale);
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var stream, self, backTimer;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 200625 ivypark, v1.0.0a deeplink 추가 - v1.1.1: AppModal 추가로 인한 삭제 - v1.1.1-rc4: kakaotalk 브라우저 이슈로 재 추가
              //210218 add Entrance page : 제거
              // if (mobile.isMobile && mobile.isNotSupported) {
              //   this.appModal = true;
              //   if (!mobile.isSafari){
              //     location.href = `Intent://kp.cococall${window.location.href.indexOf('/room/') > -1 ? `?roomid=${window.location.href.split('/room/')[1]}` : ``}#Intent;scheme=kpoint;package=kr.co.knowledgepoint.knowledgetalkccc;end`;
              //     return false;
              //   }
              // }

              if (__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile) {
                // 200622 ivypark, v0.9.4. mobile 코드 추가 (back 버튼, 방 나가기 이벤트)
                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(window, { kpCCC_Android: {} });
                window.showExitPopup = __WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].showExitPopup;
                window.exitRoom = __WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].exitRoom;
                // 200713 ivypark. v1.0.6. 모바일 화면에서 메뉴가이드 메시지 변경
                _this.buttonInfo.message = _this.$t('call-menu-information-app-1');
              }

              // 200618 ivypark, v0.9.3. 새로 고침 시 동일한 방에 입장이 불가능 하도록 변경. 변경 실패. TODO.
              // if (window.performance) {
              //   console.info("window.performance is supported");
              // }
              // if (performance.navigation.type === 1) {
              //   webRTC.clear();
              //   window.location.href = '/';
              //   return false;
              // }

              //210218 add Entrance page 
              if (!_this.$store.state.checkEntrance) {
                _this.$router.replace({ path: '/entrance/' + window.location.href.split('/room/')[1] });
              }

              // 200616 ivypark, v0.9.1. 이벤트 중복 적용 방어. (통화 종료 후 다시 render 시 $on listener가 중복으로 적용 되는 현상 발견)
              if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */]._events).length) __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */]._events = {};
              __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */].$on('video', function (param) {
                if (param.type === 'add') {
                  _this.addVideo(param.isLocal, param.id, param.stream, param.info);
                  _this.setDisplay(param.count, param.id, _this.share);
                } else if (param.type === 'remove') {
                  _this.removeVideo(param.id);
                  _this.setDisplay(param.count, param.id, _this.share);
                } else if (param.type === 'set') {
                  __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */].$emit('setVideo', param);
                  // this.setVideo(param);
                }
              });

              __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */].$on('share', function (param) {
                if (param.type === 'add') {
                  _this.addVideo(param.isLocal, param.id, param.stream);
                  _this.changeDisplay(param.type === 'add', param.count);
                } else if (param.type === 'remove') {
                  var isSharer = param.hasOwnProperty('isSharer') ? param.isSharer : _this.share && _this.share.isSharer ? _this.share.isSharer : false;
                  _this.handleShareEndBtnClick(isSharer);
                }
              });

              __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */].$on('popup', function (param) {
                _this.popup.on = param.on;
                _this.popup.type = param.type;
                _this.popup.title = param.title;
                _this.popup.contents = param.contents;
                _this.popup.option = param.option;
                _this.popup.ok = param.ok;
                _this.popup.cancel = param.cancel;
              });

              // 200702 ivypark, v1.0.1. 토스트 <-> 팝업 분리 (확인 버튼 클릭 시 팝업 창 종료를 위해)
              __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */].$on('toast', function (content) {
                _this.emitToast(content);
              });

              //210218 add Entrance page
              if (_this.$store.state.videoStatus['local']) {
                _this.isOffMic = _this.$store.state.videoStatus['local'].micOff;
                _this.isOffVideo = _this.$store.state.videoStatus['local'].camOff;
                stream = _this.$store.state.streamInfo['local'];

                _this.addVideo(true, 'local', stream, { name: _this.$store.state.userInfo.name, isOffVideo: _this.isOffVideo, isOffMic: _this.isOffMic });
              }

              // if (await webRTC.checkMediaDevices()) {
              //   // 200826 ivypark, v1.1.1. 모바일 웹브라우저 동작 팝업 추가
              //   if (mobile.isMobile && !mobile.isWebView && !mobile.isPlayBrowser) {
              //     this.appModal = true;
              //     this.appModalCallback = async () => {
              //       this.appModal = false;

              //       // 200826 ivypark, v1.1.1. 모바일 웹브라우저 동작 팝업 추가
              //       let stream = await webRTC.createVideoStream();
              //       this.addVideo(true, 'local', stream);

              //       // 200730 ivypark, v1.1.0b. 비즈니스 버전 (ip, cp 체크)
              //       utils.setPrivateInfo(this.$route.params.cp);
              //       this.init();
              //     }
              //   } else {
              //     // 200826 ivypark, v1.1.1. 모바일 웹브라우저 동작 팝업 추가
              //     let stream = await webRTC.createVideoStream();
              //     this.addVideo(true, 'local', stream);

              //     // 200730 ivypark, v1.1.0b. 비즈니스 버전 (ip, cp 체크)
              //     utils.setPrivateInfo(this.$route.params.cp);
              //     this.init();
              //   }
              // } else {
              //   if (this.$store.state.socket && this.$store.state.roomInfo) {
              //     webRTC.destroyRoom();
              //     webRTC.clear();
              //   }
              //   this.$router.push({ path: '/' });
              // }

              // 210208 mz, mobile background 전환 25초 후 종료
              self = _this;
              backTimer = null;

              document.addEventListener('visibilitychange', function () {
                if (document.visibilityState) {
                  if (__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile && document.visibilityState === 'hidden') {
                    self.isBackground = true;
                    backTimer = setTimeout(function () {
                      if (self.isBackground) __WEBPACK_IMPORTED_MODULE_4__commons_eventBus__["a" /* eBus */].$emit('exitCall');
                    }, 25 * 1000);
                  } else if (document.visibilityState === 'visible') {
                    self.isBackground = false;
                    if (backTimer) clearTimeout(backTimer);
                  }
                }
              });

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  destroyed: function destroyed() {
    // 200730 ivypark, v1.0.8. 통화 중 브라우저 뒤로 가기 버튼 누를 시 연결이 끊기지 않는 문제 수정
    __WEBPACK_IMPORTED_MODULE_6__commons_webrtc__["a" /* default */].clear();
    try {
      cocolib.audioSafe.stop();
    } catch (e) {
      // console.log(e)
    }
  },

  methods: {
    init: function init() {
      //210218 add Entrance page 
      // if (mobile.isMobile) {
      //   // 200708 ivypark. v1.0.4. 모바일 화면에서 연결/종료가 되지 않는 문제 수정
      //   const session = !this.$store.state.socket ? new Session() : this.$store.state.socket;
      //   if (await session.connect()) {
      //     sendMessage('RoomJoin', { roomId: window.location.href.split('/room/')[1] });
      //   } else {
      //     session.close();
      //   }
      //   return false;
      // }

      // 200707 ivypark, v1.0.4. 최초 입장 시 디바이스 설정 다시 보지 않기에 체크 되어있다면 팝업 띄우지 않기
      // let isChecked = window.localStorage.getItem('IS_CHECKED_DEVICE') && JSON.parse(window.localStorage.getItem('IS_CHECKED_DEVICE').toLowerCase())
      // if (isChecked) {
      //   const session = !this.$store.state.socket ? new Session() : this.$store.state.socket;
      //   if (await session.connect()) {
      //     sendMessage('RoomJoin', { roomId: window.location.href.split('/room/')[1] });
      //   } else {
      //     session.close();
      //   }
      // } else {
      //   this.popup.on = true;
      //   this.popup.type = 'Settings';
      //   this.popup.title = this.$t('popup-setting-devices-title');
      //   this.popup.contents = this.$t('popup-setting-devices-contents-1');
      //   // this.popup.option.inCall = false;
      //   this.popup.ok = async () => {
      //     const session = !this.$store.state.socket ? new Session() : this.$store.state.socket;
      //     if (await session.connect()) {
      //       sendMessage('RoomJoin', { roomId: window.location.href.split('/room/')[1] });
      //       eBus.$emit('setVideo', {
      //         type: 'set',
      //         id: 'local',
      //         deviceSetting: {
      //           done: true
      //         }
      //       });
      //     } else {
      //       session.close();
      //     }
      //   }
      //   this.popup.cancel = () => {
      //     window.location.href = '/';
      //   }
      // }

      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleBtnArea: function handleBtnArea(e) {
      // 200625 ivypark, v1.0.0a 모바일과 버튼 이벤트 분리. 모바일은 화면 터치 시 버튼 나오도록 출력 개선
      if (__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile && e.type === 'click') {
        this.visibleBtnArea = !this.visibleBtnArea;
      } else if (!__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile && e.type !== 'click') {
        var style = 'position:fixed;display:flex;justify-content:center;align-items:flex-end;width:100%;bottom:0;height:20px;';
        this.visibleBtnArea = e.type === 'mouseover' && e.target === this.$refs.btnArea || e.type !== 'mouseover' && (e.target !== this.$refs.btnArea || e.target !== this.$refs.btn);
        this.$refs.btnArea.style = e.target !== this.$refs.mainVideo ? style + 'z-index:9' : style + 'z-index:11';
      }

      if (this.buttonInfo && this.visibleBtnArea) this.buttonInfo = false;
    },
    emitToast: function emitToast(content) {
      var _this3 = this;

      // 200702 ivypark, v1.0.1. 토스트 <-> 팝업 분리 (확인 버튼 클릭 시 팝업 창 종료를 위해)
      clearTimeout(this.timeout);
      this.toast = content;
      // 200702 ivypark, v1.0.1. 토스트 팝업 출력 1.5초로 변경
      // 200617 ivypark, v0.9.2. 토스트 팝업 출력 3초로 변경
      this.timeout = setTimeout(function () {
        _this3.toast = '';
      }, 1500);
    },
    handlePopupOkBtnClick: function handlePopupOkBtnClick(param) {
      this.popup.on = false;
      if (this.popup.ok) this.popup.ok(param);
    },
    handlePopupCancelBtnClick: function handlePopupCancelBtnClick(param) {
      this.popup.on = false;
      if (this.popup.cancel) this.popup.cancel(param);
    },
    handleShareEndBtnClick: function handleShareEndBtnClick(isSharer) {
      var s = this.$store.state;
      this.removeVideo('screen');
      this.changeDisplay(false, s.roomInfo.count);
      if (isSharer) {
        Object(__WEBPACK_IMPORTED_MODULE_5__commons_message__["b" /* sendMessage */])('SessionReserveEnd', { userId: s.userInfo.id, roomId: s.roomInfo.roomId });
        Object(__WEBPACK_IMPORTED_MODULE_5__commons_message__["b" /* sendMessage */])('ScreenShareConferenceEnd', { userId: s.userInfo.id, roomId: s.roomInfo.roomId, useMediaSvr: s.roomInfo.count > 2 ? 'Y' : 'N' });
      }
    },
    handleCollapseBtnClick: function handleCollapseBtnClick() {
      this.isCollapsedVideo = !this.isCollapsedVideo;
    },
    addVideo: function addVideo(isLocal, id, stream, info) {
      if (id === 'screen') {
        this.share = {
          id: 'screen',
          isSharer: isLocal,
          stream: stream
        };

        document.getElementById('ShareVideo').srcObject = stream;
        document.getElementById('ShareVideo').playsInline = true;
        document.getElementById('ShareVideo').autoplay = true;
      } else {
        // 200618 ivypark, v0.9.3. 기존 참여자가 카메라/마이크를 끈 상태로 신규 참여자 입장 시 Off 화면이 아닌 검정색 화면으로 출력, Mic Off 표시도 없던 문제 수정
        // Redis에 저장된 각각의 사용자의 이름, 비디오/마이크Off 여부를 Join시 Room 정보와 함께 전달 받아서 이곳에서 Video div로 출력함
        this.videos.push({
          id: isLocal ? 'local' : id,
          userName: info && info.name && info.name !== 'unknown' ? info.name : '익명',
          isOffVideo: info && info.isOffVideo ? info.isOffVideo : false,
          isOffMic: info && info.isOffMic ? info.isOffMic : false,
          isBgBlur: info && info.isBgBlur ? info.isBgBlur : false,
          isLocal: isLocal
        });
      }
    },
    setVideo: function setVideo(param) {
      // 200615 ivypark, is NOT working (does not become re-rendering)....................
      // this.videos.forEach((curr, idx) => {
      //   if (curr.id === param.id && param.hasOwnProperty('isOffVideo')) {
      //     this.$set(this.videos, idx, Object.assign({}, this.videos[idx], { isOffVideo: param.isOffVideo }));
      //   }
      //   if (curr.id === param.id && param.hasOwnProperty('isOffMic')) {
      //     let list = [...this.videos];
      //     let obj = Object.assign({}, this.videos[idx], { isOffMic: param.isOffMic });
      //     list.splice(idx, 1, obj);
      //     this.videos = list;
      //   }
      //   if (curr.id === param.id && param.hasOwnProperty('name')) {
      //   }
      // })
    },
    removeVideo: function removeVideo(id) {
      if (id === 'screen') {
        this.$store.commit('removePeerInfo', id);
        this.$store.commit('removeStreamInfo', id);
        this.share = null;
        document.getElementById('ShareVideo').srcObject = null;
      } else {
        if (!id) {
          this.videos = [];
          return;
        }

        this.$store.commit('removePeerInfo', id);
        this.$store.commit('removeStreamInfo', id);
        this.videos = this.videos.filter(function (c) {
          return c.id !== id;
        });
      }
    },
    changeDisplay: function changeDisplay(isSharing, count) {
      if (isSharing) {
        // when started screen sharing
        document.getElementById('MainVideoContainer').appendChild(document.getElementById('MainVideo'));
        if (document.getElementById('local')) document.getElementById('local').classList.remove('local');
        this.setDisplay(undefined, undefined, true);
      } else {
        // when stopped screen sharing
        document.getElementById('VideoContainer').appendChild(document.getElementById('MainVideo'));
        if (document.getElementById('local') && count <= 2) document.getElementById('local').classList.add('local');
        this.setDisplay(this.$store.state.roomInfo.count, undefined, false);
      }
    },
    setDisplay: function setDisplay(count, id, isSharing) {
      var _this4 = this;

      this.detachOffVideo();
      var isHighResolution = __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].state.highResolution;

      if (isSharing) {
        this.videoDisplayType = '';
        this.constraint.width.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).share.width;
        this.constraint.height.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).share.height;
        this.constraint.frameRate.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).share.frameRate;
        __WEBPACK_IMPORTED_MODULE_6__commons_webrtc__["a" /* default */].setConstraint(this.constraint);
        return false;
      }

      if (count > 2) {
        if (document.getElementById('local')) document.getElementById('local').classList.remove('local');
        this.videos.forEach(function (c, idx) {
          // 기존 1:1에서 나왔던 remote 영상 삭제
          if (c.id === 'remote') {
            // this.$store.commit('removePeerInfo', 'local');
            _this4.$store.commit('removeStreamInfo', 'remote');
            _this4.videos.splice(idx, 1);
          }
        });
      } else if (count <= 2) {
        if (document.getElementById('local')) document.getElementById('local').classList.add('local');
      }

      // 210208 modify white screen issue
      var displayCount = 1;
      switch (count) {
        // 200617 ivypark, v0.9.2. 1명일 때 OffVideo 출력 되도록 변경
        case 1:
          if (count === 1) {
            this.videoDisplayType = 'one';
          }
        case 2:
          if (count === 2) {
            this.videoDisplayType = 'two';
          }
          this.constraint.width.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).p2p.width;
          this.constraint.height.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).p2p.height;
          this.constraint.frameRate.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).p2p.frameRate;
          break;

        case 3:
        case 4:
          displayCount = 4;
          this.videoDisplayType = 'four';
          this.constraint.width.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).four.width;
          this.constraint.height.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).four.height;
          this.constraint.frameRate.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).four.frameRate;
          break;

        case 5:
        case 6:
          displayCount = 6;
          this.videoDisplayType = 'six';
          this.constraint.width.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).six.width;
          this.constraint.height.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).six.height;
          this.constraint.frameRate.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).six.frameRate;
          break;

        case 7:
        case 8:
        case 9:
          displayCount = 9;
          this.videoDisplayType = 'nine';
          this.constraint.width.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).nine.width;
          this.constraint.height.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).nine.height;
          this.constraint.frameRate.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).nine.frameRate;
          break;

        case 10:
        case 11:
        case 12:
          displayCount = 12;
          this.videoDisplayType = 'twelve';
          this.constraint.width.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).twelve.width;
          this.constraint.height.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).twelve.height;
          this.constraint.frameRate.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).twelve.frameRate;
          break;

        // case 13: 
        // case 14:
        // case 15:
        // case 16: 
        default:
          displayCount = 16;
          this.videoDisplayType = 'sixteen';
          this.constraint.width.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).sixteen.width;
          this.constraint.height.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).sixteen.height;
          this.constraint.frameRate.ideal = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].getConstraint(isHighResolution).sixteen.frameRate;
          break;
      }
      if (count > 16) {
        console.warn('ambiguous remain value');
      }
      if (count > 2) {
        this.detachOffVideo();
        this.attachOffVideo(displayCount - this.videos.length);
      }
      __WEBPACK_IMPORTED_MODULE_6__commons_webrtc__["a" /* default */].setConstraint(this.constraint);
    },
    attachOffVideo: function attachOffVideo(cnt) {
      for (var i = 0; i < cnt && this.offVideos.length < cnt; i++) {
        this.offVideos.push('<div class="video off"></div>');
      }
    },
    detachOffVideo: function detachOffVideo() {
      this.offVideos = [];
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_mobile__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: { isLocal: Boolean, isOffVideo: Boolean, isOffMic: Boolean, isBgBlur: Boolean, vid: String, userName: String },
  data: function data() {
    return {
      loaded: false,
      isLocalVideo: this.isLocal,
      id: this.isLocal ? 'local' : this.vid,
      name: this.userName,
      offVideo: this.isOffVideo,
      offMic: this.isOffMic,
      isBlur: this.isBgBlur,
      isTalking: false,
      isNetworkBad: false,
      report: null,
      bytes: 0,
      packets: 0,
      isStartFromPopup: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.attachVideo(this.isOffVideo);
    // if (!this.isOffVideo) this.attachVideo();

    //network condition check
    __WEBPACK_IMPORTED_MODULE_2__commons_eventBus__["a" /* eBus */].$on('networkCondition', function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(param) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (param.userId === _this.id) {

                  //when network condition is bad
                  if (param.hasOwnProperty('isGood') && !param.isGood) {
                    _this.isNetworkBad = true;

                    //camera
                    _this.offVideo = false;

                    _this.$refs.video.querySelector('video').style = "display: none";
                  }
                  //when network condition is good
                  else if (param.hasOwnProperty('isGood') && param.isGood) {

                      _this.isNetworkBad = false;

                      if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.videoStatus[_this.id].cam) {
                        _this.offVideo = true;
                      } else {
                        _this.$refs.video.querySelector('video').style = "display: block";
                      }
                    }
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    //화자감지 기능 분리
    __WEBPACK_IMPORTED_MODULE_2__commons_eventBus__["a" /* eBus */].$on('showsSpeaker', function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(param) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //local video event 지속적인 처리 필요
                _this.isLocalVideo = _this.id === 'local' && (!_this.$store.state.roomInfo.count || _this.$store.state.roomInfo.count <= 2) && !_this.$store.state.streamInfo.screen;
                if (param.hasOwnProperty('setShows') && !param.setShows) _this.isTalking = false; //화자감지 표시 중 기능 off 시 효과 없애기
                if (param.hasOwnProperty('userId') && param.hasOwnProperty('isTalking') && param.userId === _this.id) {
                  console.debug('isTalking : ', param.isTalking, ' / userId : ', param.userId);
                  _this.isTalking = param.isTalking; //화자감지 on
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    __WEBPACK_IMPORTED_MODULE_2__commons_eventBus__["a" /* eBus */].$on('setVideo', function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(param) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 200618 ivypark, v0.9.2. 1:1 공유 중 cam/mic off 시 로컬화면이 분리되는 현상 수정
                _this.isLocalVideo = _this.id === 'local' && (!_this.$store.state.roomInfo.count || _this.$store.state.roomInfo.count <= 2) && !_this.$store.state.streamInfo.screen;

                if (param.id === _this.id && param.hasOwnProperty('name')) _this.name = param.name;
                if (param.id === _this.id && param.hasOwnProperty('isOffMic')) _this.offMic = param.isOffMic;
                if (param.id === _this.id && param.hasOwnProperty('isOffVideo')) {
                  // 200702 ivypark, v1.0.1. 비디오 off 시 소리 들리지 않는 현상 수정. (기존 비디오 삭제 -> display: none, block으로 변경되도록 수정)
                  _this.$refs.video.querySelector('video').style = param.isOffVideo ? "display: none" : "display: block";
                  _this.offVideo = param.isOffVideo;
                }

                if (!(param.id === _this.id && param.hasOwnProperty('deviceSetting'))) {
                  _context3.next = 15;
                  break;
                }

                _this.$refs.video.querySelector('video').muted = true;

                if (!param.deviceSetting.stream) {
                  _context3.next = 11;
                  break;
                }

                _this.$refs.video.querySelector('video').srcObject = null;
                _this.$refs.video.querySelector('video').srcObject = param.deviceSetting.stream;
                _context3.next = 11;
                return _this.$refs.video.querySelector('video').play();

              case 11:
                if (param.deviceSetting.hasOwnProperty('done')) {
                  // 자기 목소리 들리는 현상 수정
                  if (param.deviceSetting.done === true) _this.isStartFromPopup = true;
                  if (_this.isStartFromPopup === false) _this.$refs.video.querySelector('video').muted = param.deviceSetting.done;
                }

                if (!param.deviceSetting.hasOwnProperty('sinkId')) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 15;
                return _this.$refs.video.querySelector('video').setSinkId(param.deviceSetting.sinkId);

              case 15:
                if (param.id === _this.id && param.hasOwnProperty('isBlur')) {
                  // 201027 ivypark, v1.1.7. 사생활 보호 기능 추가
                  _this.isBlur = param.isBlur;
                  _this.isBlur ? _this.blur() : _this.unblur();
                }

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  destroyed: function destroyed() {
    this.unblur();
  },

  methods: {
    attachVideo: function attachVideo(isOff) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var video;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                video = document.createElement('video');

                video.srcObject = _this2.$store.state.streamInfo[_this2.isLocalVideo ? 'local' : _this2.$store.state.roomInfo.type === 'p2p' ? 'remote' : _this2.id];
                video.autoplay = true;
                video.muted = _this2.isLocalVideo;
                video.playsInline = true;
                if (_this2.$refs.video.firstChild) _this2.$refs.video.insertBefore(video, _this2.$refs.video.firstChild);
                // 200714 ivypark, v1.0.7. 화면 off후 신규 참가자 입장 시 카메라 화면이 출력되지 않는 문제 수정
                _this2.$refs.video.querySelector('video').style = isOff ? "display: none" : "display: block";
                _this2.$refs.video.querySelector('video').onloadeddata = function () {
                  _this2.loaded = true;
                };

                if (!_this2.isBlur) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 11;
                return _this2.blur();

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    handleChangeName: function handleChangeName() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__commons_eventBus__["a" /* eBus */].$emit('popup', {
        on: true,
        type: 'ChangeName',
        title: this.$t('popup-change-name-title'),
        ok: function ok(param) {
          _this3.name = param.name;
        }
      });
    },
    blur: function blur() {
      cocolib.privacyMode.start(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.peerInfo['local'], this.$refs.canvas, this.$refs.video.querySelector('video'), { width: 960, height: 540 }, 19, 5, false);
      __WEBPACK_IMPORTED_MODULE_2__commons_eventBus__["a" /* eBus */].$emit('toast', '사생활 보호 기능 로딩 중입니다. 잠시만 기다려주세요.');
    },
    unblur: function unblur() {
      cocolib.privacyMode.stop(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.peerInfo['local'], __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.streamInfo['local']);
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_webrtc__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_mobile__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: { isVisible: Boolean },
  data: function data() {
    return {
      isWebView: __WEBPACK_IMPORTED_MODULE_3__commons_mobile__["a" /* default */].isWebView,
      isMobile: __WEBPACK_IMPORTED_MODULE_3__commons_mobile__["a" /* default */].isMobile,
      isOffVideo: false,
      isOffMic: false,
      showsSpeaker: false,
      isBgBlur: false,
      showsMore: false,
      btnStrTalking: this.showsSpeaker ? this.$t('button-shows-speaker-off') : this.$t('button-shows-speaker-on'),
      btnStrBlur: this.isBgBlur ? this.$t('button-bg-blur-off') : this.$t('button-bg-blur-on')
    };
  },
  mounted: function mounted() {
    var _this = this;

    // 210218 add entrance page : adjsut entrance settings
    var s = this.$store.state;
    if (s.videoStatus.hasOwnProperty('local')) {
      this.isOffMic = s.videoStatus['local'].micOff;
      this.isOffVideo = s.videoStatus['local'].camOff;
    }
    if (this.isOffMic) {
      if (s.streamInfo.local) {
        var tracks = s.streamInfo.local.getTracks();
        tracks.forEach(function (curr) {
          if (curr.kind === 'audio') {
            curr.enabled = !_this.isOffMic;
          }
        });
      }
    }

    //화자감지 on/off
    __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$on('showsSpeaker', function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(param) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (param.hasOwnProperty('setShows')) {
                  _this.$store.commit('setShowsSpeaker', param.setShows);
                  _this.showsSpeaker = param.setShows;
                  _this.btnStrTalking = _this.showsSpeaker ? _this.$t('button-shows-speaker-off') : _this.$t('button-shows-speaker-on');
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    //blur stop
    __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$on('blurStop', function () {
      _this.handleBgBlurBtn();
    });

    //blur Again
    __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$on('blurAgain', function () {
      _this.handleBgBlurBtn();
      _this.handleBgBlurBtn(false);
    });

    // 210202 mz, mobile background 전환 20초 후 종료
    __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$on('exitCall', function () {
      Object(__WEBPACK_IMPORTED_MODULE_4__commons_message__["b" /* sendMessage */])('ExitRoom', { roomId: window.location.href.split('/room/')[1] });
      if (_this.isBgBlur) {
        cocolib.privacyMode.stop(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.peerInfo['local'], __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.streamInfo['local']);
      }
      __WEBPACK_IMPORTED_MODULE_2__commons_webrtc__["a" /* default */].clear();
      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('video', { type: 'remove' });
      _this.$router.push({ path: '/' });
    });
  },
  updated: function updated() {
    // buttonContainer invisible 되면 더보기 dropbox도 invisible 되도록
    if (!this.isVisible) this.showsMore = false;
  },

  methods: {
    handleJoinBtn: function handleJoinBtn() {
      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
        on: true,
        type: 'Join',
        title: this.$t('popup-another-meeting-title')
      });
    },
    handleInviteBtn: function handleInviteBtn() {
      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
        on: true,
        type: 'Invite',
        title: this.$t('popup-invite-title')
      });
    },
    handleScreenShareBtn: function handleScreenShareBtn() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var s;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_3__commons_mobile__["a" /* default */].isMobile) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
                  on: true,
                  type: 'Alert',
                  title: _this2.$t('popup-screen-share-title'),
                  contents: _this2.$t('popup-screen-share-contents-failed-2')
                }));

              case 2:
                s = _this2.$store.state;

                if (!(s.roomInfo.count <= 1 || s.streamInfo.screen)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
                  on: true,
                  type: 'Alert',
                  title: _this2.$t('popup-screen-share-title'),
                  contents: _this2.$t('popup-screen-share-contents-failed-1')
                }));

              case 7:
                Object(__WEBPACK_IMPORTED_MODULE_4__commons_message__["b" /* sendMessage */])('SessionReserve', { userId: s.userInfo.id, roomId: s.roomInfo.roomId });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleCamBtn: function handleCamBtn() {
      var _this3 = this;

      //when blur is on
      if (this.isBgBlur) {
        this.handleBgBlurBtn();
      }

      this.isOffVideo = !this.isOffVideo;

      var s = this.$store.state;
      Object(__WEBPACK_IMPORTED_MODULE_4__commons_message__["b" /* sendMessage */])('SetVideo', { userId: s.userInfo.id, roomId: s.roomInfo.roomId, status: this.isOffVideo }, 'signalOp');

      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('video', {
        type: 'set',
        id: 'local',
        isOffVideo: this.isOffVideo
      });

      if (s.streamInfo.local) {
        var tracks = s.streamInfo.local.getTracks();
        tracks.forEach(function (curr) {
          if (curr.kind === 'video') {
            curr.enabled = !_this3.isOffVideo;
          }
        });
      }
      this.$store.commit('setVideoStatus', { userId: 'local', camOff: this.isOffVideo });
    },
    handleMicBtn: function handleMicBtn() {
      var _this4 = this;

      this.isOffMic = !this.isOffMic;

      var s = this.$store.state;
      Object(__WEBPACK_IMPORTED_MODULE_4__commons_message__["b" /* sendMessage */])('SetAudio', { userId: s.userInfo.id, roomId: s.roomInfo.roomId, status: this.isOffMic }, 'signalOp');

      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('video', {
        type: 'set',
        id: 'local',
        isOffMic: this.isOffMic
      });

      if (s.streamInfo.local) {
        var tracks = s.streamInfo.local.getTracks();
        tracks.forEach(function (curr) {
          if (curr.kind === 'audio') {
            curr.enabled = !_this4.isOffMic;
          }
        });
      }
      this.$store.commit('setVideoStatus', { userId: 'local', micOff: this.isOffMic });
    },
    handleTalkingBtn: function handleTalkingBtn() {
      //2명 이하 시 미지원
      if (this.$store.state.roomInfo.count < 3) {
        __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
          on: true,
          type: 'Alert',
          title: '화자 감지',
          contents: '사용자가 3명 이상일 때 사용 가능합니다.'
        });
        return;
      }
      //toggle
      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('showsSpeaker', {
        setShows: !this.showsSpeaker
      });
    },
    handleBgBlurBtn: function handleBgBlurBtn() {
      var alert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (__WEBPACK_IMPORTED_MODULE_3__commons_mobile__["a" /* default */].isMobile) {
        __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
          on: true,
          type: 'Alert',
          title: '사생활 보호',
          contents: '사생활 보호 기능은 PC Web 에서 지원합니다.'
        });
        return;
      }

      if (this.isOffVideo) {
        this.handleCamBtn();
      }

      //다른 참여자들이 모두 퇴장하여 혼자 남아있는 경우 사생활보호 끄기
      if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.count <= 1 && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoStatus['local'] && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.videoStatus['local'].blur) {
        this.isBgBlur = !this.isBgBlur;
        this.btnStrBlur = this.isBgBlur ? this.$t('button-bg-blur-off') : this.$t('button-bg-blur-on');

        __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('video', {
          type: 'set',
          id: 'local',
          isBlur: this.isBgBlur
        });

        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoStatus', { userId: 'local', cam: true, audioSafe: false, blur: false });

        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.count > 1) {
        this.isBgBlur = !this.isBgBlur;
        this.btnStrBlur = this.isBgBlur ? this.$t('button-bg-blur-off') : this.$t('button-bg-blur-on');

        __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('video', {
          type: 'set',
          id: 'local',
          isBlur: this.isBgBlur
        });
        if (this.isBgBlur) {
          if (alert) {
            __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
              on: true,
              type: 'Alert',
              title: '사생활 보호',
              contents: '상대방에게 사생활 보호 기능이 적용 됩니다.'
            });
          }

          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoStatus', { userId: 'local', cam: true, audioSafe: false, blur: true });
        } else {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setVideoStatus', { userId: 'local', cam: true, audioSafe: false, blur: true });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
          on: true,
          type: 'Alert',
          title: '사생활 보호',
          contents: '지금은 사생활 보호 기능을 사용할 수 없습니다.'
        });
      }
    },
    handleSettingBtn: function handleSettingBtn() {
      // 200706 ivypark, v1.0.3. 디바이스 세팅 팝업 추가
      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
        on: true,
        type: 'Settings',
        title: this.$t('popup-setting-devices-title'),
        contents: this.$t('popup-setting-devices-contents-2'),
        option: { inCall: true },
        ok: function ok() {
          __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('setVideo', {
            type: 'set',
            id: 'local',
            deviceSetting: {
              done: true
            }
          });
        },
        cancel: function cancel() {
          // 200715 ivypark, v1.0.7. 디바이스 설정 팝업에서 X 버튼 누를 시 본인의 목소리가 나오던 문제 수정
          __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('setVideo', {
            type: 'set',
            id: 'local',
            deviceSetting: {
              done: true
            }
          });
        }
      });
    },
    handleEndCallBtn: function handleEndCallBtn() {
      // 200617 ivypark, v0.9.2. 통화 종료 팝업 추가
      __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('popup', {
        on: true,
        type: 'Confirm',
        title: this.$t('popup-end-call-title'),
        contents: this.$t('popup-end-call-contents'),
        ok: function ok() {
          __WEBPACK_IMPORTED_MODULE_5__commons_eventBus__["a" /* eBus */].$emit('exitCall');
        }
      });
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_webrtc__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_session__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppModal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Popup__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_mobile__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Popup: __WEBPACK_IMPORTED_MODULE_5__components_Popup__["a" /* default */], AppModal: __WEBPACK_IMPORTED_MODULE_4__components_AppModal__["a" /* default */] },
    data: function data() {
        return {
            offMic: false,
            offVideo: false,
            name: '',
            popup: {
                on: false,
                type: '',
                title: '',
                contents: '',
                option: {},
                ok: null,
                cancel: null
            },
            appModal: false,
            isMoblile: __WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile
        };
    },
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var roomId, session, stream, video;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile && __WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isNotSupported)) {
                                _context.next = 6;
                                break;
                            }

                            _this.appModal = true;

                            if (__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isSafari) {
                                _context.next = 6;
                                break;
                            }

                            //kakao browser -> 앱 설치 or 앱 실행
                            roomId = window.location.href.indexOf('/entrance/') > -1 ? window.location.href.split('/entrance/')[1] : '';

                            location.href = 'Intent://kp.cococall' + (roomId !== '' ? '?roomid=' + roomId : '') + '#Intent;scheme=kpoint;package=kr.co.knowledgepoint.knowledgetalkccc;end';
                            return _context.abrupt('return', false);

                        case 6:
                            if (__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile && !__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isWebView && !__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isPlayBrowser) {
                                _this.appModal = true;
                            }
                            if (__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile && __WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isWebView) {
                                window.mobileBackBtn = __WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].mobileBackBtn;
                            }

                            if (!_this.$store.state.socket) {
                                session = new __WEBPACK_IMPORTED_MODULE_3__commons_session__["a" /* default */]();

                                session.connect();
                            }

                            _context.next = 11;
                            return __WEBPACK_IMPORTED_MODULE_2__commons_webrtc__["a" /* default */].checkMediaDevices();

                        case 11:
                            if (!_context.sent) {
                                _context.next = 20;
                                break;
                            }

                            _context.next = 14;
                            return __WEBPACK_IMPORTED_MODULE_2__commons_webrtc__["a" /* default */].createVideoStream(true);

                        case 14:
                            stream = _context.sent;
                            video = document.querySelector('video');

                            video.srcObject = stream;
                            video.autoplay = true;
                            video.muted = true;
                            video.playsInline = true;

                        case 20:

                            //모바일 브라우저 뒤로가기 이벤트 :  떠있는 창 끄거나 메인으로
                            __WEBPACK_IMPORTED_MODULE_6__commons_eventBus__["a" /* eBus */].$on('mobilebackbtn', function () {
                                if (_this.popup.on) _this.popup.on = false;else _this.closeEntrance();
                            });

                            __WEBPACK_IMPORTED_MODULE_6__commons_eventBus__["a" /* eBus */].$on('popup-enter', function (param) {
                                _this.popup.on = param.on;
                                _this.popup.type = param.type;
                                _this.popup.title = param.title;
                                _this.popup.contents = param.contents;
                                _this.popup.option = param.option;
                                _this.popup.ok = param.ok;
                                _this.popup.cancel = param.cancel;
                            });

                            if (!__WEBPACK_IMPORTED_MODULE_8__commons_mobile__["a" /* default */].isMobile) document.getElementsByTagName('input')[0].focus();

                        case 23:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    beforeDestroy: function beforeDestroy() {
        // 210303 모바일웹 종료 이슈 수정
        this.$refs.video.srcObject = null;
    },

    methods: {
        typingName: function typingName(e) {
            this.name = e.target.value;
        },
        handleSettingBtn: function handleSettingBtn() {
            __WEBPACK_IMPORTED_MODULE_6__commons_eventBus__["a" /* eBus */].$emit('popup-enter', {
                on: true,
                type: 'Settings',
                title: this.$t('popup-setting-devices-title'),
                contents: this.$t('popup-setting-devices-contents-1'),
                option: { inCall: false },
                ok: function ok() {
                    __WEBPACK_IMPORTED_MODULE_6__commons_eventBus__["a" /* eBus */].$emit('popup-enter', { on: false });
                    __WEBPACK_IMPORTED_MODULE_6__commons_eventBus__["a" /* eBus */].$emit('setVideo', { //to Video.vue
                        type: 'set',
                        id: 'local',
                        deviceSetting: { done: true } });
                },
                cancel: function cancel() {
                    __WEBPACK_IMPORTED_MODULE_6__commons_eventBus__["a" /* eBus */].$emit('popup-enter', { on: false });
                }
            });
        },
        handleStartBtn: function handleStartBtn() {
            if (this.name.trim().length === 0) {
                this.name = '익명';
            }
            Object(__WEBPACK_IMPORTED_MODULE_7__commons_message__["b" /* sendMessage */])('RoomJoinWithName', { roomId: window.location.href.split('/entrance/')[1], name: this.name, offVideo: this.offVideo, offMic: this.offMic });
            this.$store.commit('checkEntrance', true);
            this.$store.commit('setUserInfo', { name: this.name });
            this.$store.commit('setVideoStatus', { userId: 'local', camOff: this.offVideo, micOff: this.offMic });
        },
        closeEntrance: function closeEntrance() {
            window.location.href = '/';
        },
        handleAppModalClose: function handleAppModalClose() {
            this.appModal = false;
        }
    }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(236);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  i18n: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d57e9e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(117);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d57e9e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */,
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 118 */,
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0993472_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(210);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0993472_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__message__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__eventBus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(9);











var ScreenShare = function () {
  function ScreenShare() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ScreenShare);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ScreenShare, [{
    key: 'createShareStream',
    value: function createShareStream() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // 200703 ivypark, v1.0.2. getDisplayMedia 데이터 없는 경우 SessionReserve 해제되도록 변경
                  // 200617 ivypark, v0.9.2. 에러 무시. Stream 안나온 경우 에러팝업 뜨지 않도록 변경
                  // 210218 screen audio 포함
                  navigator.mediaDevices.getDisplayMedia({ video: true, audio: { echoCancellation: true } }).then(function (stream) {
                    if ((typeof stream === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(stream)) === 'object' && stream) {
                      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setStreamInfo', { screen: stream });
                      resolve(stream);
                    }
                  }).catch(function (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__message__["b" /* sendMessage */])('SessionReserveEnd', { userId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.userInfo.id, roomId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.roomId });
                  });

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'createPeer',
    value: function createPeer(uid, isMulti, pluginId) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var peer, peerCount, peerObj, s;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  peer = new RTCPeerConnection(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].iceServer[__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].env][isMulti ? 'media' : 'p2p']);
                  // 200825 ivypark, legacy codes
                  // peer.onaddstream = ({ stream }) => {

                  peer.ontrack = function (_ref3) {
                    var streams = _ref3.streams;

                    console.debug('onaddstream :', streams[0]);
                    var streamObj = {};
                    streamObj[uid] = streams[0];
                    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setStreamInfo', streamObj);
                    __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('share', {
                      type: 'add',
                      id: 'screen',
                      isLocal: false,
                      stream: streams[0],
                      count: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.count
                    });
                  };

                  peer.onconnectionstatechange = function (e) {
                    console.debug('## ' + uid + ' onconnectionstatechange ## ', e.currentTarget.connectionState);
                  };
                  peer.onicegatheringstatechange = function (e) {
                    // 200703 ivypark, v1.0.2. gatheringstate -> candidate null 일때 SDP 전송으로 변경
                    if (peer.iceGatheringState === 'complete') {
                      // sendMessage('SDP', {
                      //   sdp: peer.localDescription,
                      //   usage: 'screen',
                      //   roomId: store.state.roomInfo.roomId,
                      //   isSfu: true,
                      //   userId: store.state.userInfo.id,
                      //   useMediaSvr: store.state.roomInfo.count > 2 ? 'Y' : 'N'
                      // });
                    }
                  };
                  peerCount = 0;

                  peer.onicecandidate = function (e) {
                    if (peerCount <= 0) {
                      setTimeout(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_7__message__["b" /* sendMessage */])('SDP', {
                          sdp: peer.localDescription,
                          usage: 'screen',
                          roomId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.roomId,
                          // isSfu: true,
                          userId: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.userInfo.id,
                          useMediaSvr: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.roomInfo.count > 2 ? 'Y' : 'N',
                          pluginId: pluginId
                        });
                      }, 1500);
                    }
                    peerCount++;
                  };

                  peerObj = {};

                  peerObj[uid] = peer;
                  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setPeerInfo', peerObj);

                  s = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state;

                  if (s.streamInfo[uid]) {
                    s.streamInfo[uid].getTracks().forEach(function (track) {
                      s.peerInfo['screen'].addTrack(track, s.streamInfo[uid]);
                      track.onended = function () {
                        __WEBPACK_IMPORTED_MODULE_8__eventBus__["a" /* eBus */].$emit('share', {
                          type: 'remove',
                          isSharer: true
                        });
                        track.stop();
                      };
                    });
                  }

                  resolve();

                case 12:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);

  return ScreenShare;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ScreenShare());

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeName_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b420b1f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeName_vue__ = __webpack_require__(197);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b420b1f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContent"},[_c('div',{staticClass:"userName"},[_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],ref:"nameInput",attrs:{"type":"text","placeholder":this.$t('popup-change-name-placeholder'),"maxlength":"8"},domProps:{"value":(_vm.name)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmed($event)},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('label')])]),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"submit",on:{"click":_vm.confirmed}},[_vm._v(_vm._s(this.$t('popup-submit')))]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":this.cancel}},[_vm._v(_vm._s(this.$t('popup-cancel')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a63809_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__ = __webpack_require__(199);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a63809_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContent"},[_c('p',[_vm._v(_vm._s(_vm.contents))]),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"submit",on:{"click":_vm.ok}},[_vm._v(_vm._s(this.$t('popup-submit')))]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":_vm.cancel}},[_vm._v(_vm._s(this.$t('popup-cancel')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invite_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06340b9f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invite_vue__ = __webpack_require__(201);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06340b9f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContent"},[_c('div',{staticClass:"invite"},[_c('div',{staticClass:"btn disalbed",on:{"click":_vm.handleTalkBtnClick}},[_c('button',{staticClass:"talk",attrs:{"data-title":"카카오톡"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.$t('popup-invite-kakao')))])]),_vm._v(" "),_c('div',{staticClass:"btn disalbed",on:{"click":_vm.handleSMSBtnClick}},[_c('button',{staticClass:"message",attrs:{"data-title":"문자메시지"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.$t('popup-invite-mms')))])]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":_vm.handleUrlCopyBtnClick}},[_c('button',{staticClass:"url",attrs:{"data-title":"URL 복사"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.$t('popup-invite-url')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2507eb68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(203);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2507eb68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContent"},[_c('p',[_vm._v(_vm._s(_vm.contents))]),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"submit",on:{"click":_vm.cancel}},[_vm._v(_vm._s(this.$t('popup-submit')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e699a268_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(205);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e699a268_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContent"},[_c('div',{staticClass:"setting"},[_c('ul',{staticClass:"select"},[_c('li',[_c('label',[_vm._v("Camera")]),_vm._v(" "),_c('select',{ref:"videoInput",attrs:{"disabled":this.option.inCall,"required":""},on:{"change":_vm.onChange}})]),_vm._v(" "),_c('li',{class:{ mic: !this.option.inCall }},[_c('label',[_vm._v("Microphone")]),_vm._v(" "),_c('select',{ref:"audioInput",attrs:{"disabled":this.option.inCall,"required":""},on:{"change":_vm.onChange}},[_c('option',{attrs:{"value":""}},[_vm._v("기본값 - 외장 마이크(Conexant ISST Audio)")]),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("Microphone1")]),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("Microphone2")])]),_vm._v(" "),_c('div',{staticClass:"volume",class:{ none: !_vm.isPlayTestMic }},[_c('div',{staticClass:"percent",style:(_vm.volumeHeight)},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])])]),_vm._v(" "),_c('li',{class:{ speaker: !this.option.inCall }},[_c('label',[_vm._v("Speaker")]),_vm._v(" "),_c('select',{ref:"audioOutput",attrs:{"disabled":this.option.inCall,"required":""},on:{"change":function($event){return _vm.onChangeOutput($event)}}}),_vm._v(" "),(!this.option.inCall)?_c('button',{class:{ on: _vm.isPlayTestSound },attrs:{"disabled":this.option.inCall},on:{"click":_vm.handlePlayTestSound}},[_vm._v("테스트")]):_vm._e()])])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.contents))]),_vm._v(" "),_c('div',{staticClass:"button"},[(!this.option.inCall)?_c('button',{staticClass:"cancel",on:{"click":_vm.init}},[_vm._v(_vm._s(this.$t('popup-refresh')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"submit",on:{"click":_vm.ok}},[_vm._v(_vm._s(this.$t('popup-submit')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414febf5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__ = __webpack_require__(207);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414febf5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContent"},[_c('div',{staticClass:"enterCall"},[_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],attrs:{"type":"text","placeholder":this.$t('popup-another-meeting-placeholder')},domProps:{"value":(_vm.url)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmed($event)},"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{staticClass:"submit",on:{"click":_vm.confirmed}},[_vm._v(_vm._s(this.$t('popup-submit')))]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":this.cancel}},[_vm._v(_vm._s(this.$t('popup-cancel')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modalContainer"},[_c('div',{staticClass:"modalHeader"},[_c('span',{class:{invite: _vm.contentsType === 'Invite', enter: _vm.contentsType === 'Join'}},[_vm._v(_vm._s(_vm.pTitle))]),_vm._v(" "),_c('button',{on:{"click":_vm.cancelBtnClick}},[_vm._v("닫기")])]),_vm._v(" "),(_vm.contentsType === 'ChangeName')?_c('ChangeName',{attrs:{"ok":_vm.okBtnClick,"cancel":_vm.cancelBtnClick}}):_vm._e(),_vm._v(" "),(_vm.contentsType === 'Confirm')?_c('Confirm',{attrs:{"ok":_vm.okBtnClick,"cancel":_vm.cancelBtnClick,"contents":_vm.pContents}}):_vm._e(),_vm._v(" "),(_vm.contentsType === 'Alert')?_c('Alert',{attrs:{"cancel":_vm.cancelBtnClick,"contents":_vm.pContents}}):_vm._e(),_vm._v(" "),(_vm.contentsType === 'Invite')?_c('Invite'):_vm._e(),_vm._v(" "),(_vm.contentsType === 'Settings')?_c('Settings',{attrs:{"ok":_vm.okBtnClick,"contents":_vm.pContents,"option":_vm.option}}):_vm._e(),_vm._v(" "),(_vm.contentsType === 'Join')?_c('Join',{attrs:{"ok":_vm.okBtnClick,"cancel":_vm.cancelBtnClick,"contents":_vm.pContents,"option":_vm.option}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommendAppModal"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{on:{"click":_vm.handleClickAppBtn}},[_vm._v("COCOcall 앱으로 이동")]),_vm._v(" "),(_vm.showUseMobile)?_c('a',{on:{"click":_vm.handleClickMobileWebBtn}},[_vm._v("괜찮아요. 모바일웹으로 이용할게요.")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"logo"},[_vm._v("COCOcall")]),_vm._v(" "),_c('p',[_vm._v("COCOcall을"),_c('br'),_vm._v(" APP으로 만나보세요!")]),_vm._v(" "),_c('div',{staticClass:"icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.popup.on)?_c('Popup',{attrs:{"type":_vm.popup.type,"title":_vm.popup.title,"contents":_vm.popup.contents,"option":_vm.popup.option,"ok":_vm.handlePopupOkBtnClick,"cancel":_vm.handlePopupCancelBtnClick}}):_vm._e(),_vm._v(" "),(_vm.appModal)?_c('app-modal',{attrs:{"close":_vm.handleAppModalClose}}):_vm._e(),_vm._v(" "),_c('header',{staticClass:"header"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('button',{staticClass:"lang",on:{"click":_vm.onChangeLanguage}},[_c('span',[_vm._v(_vm._s(this.$i18n.locale === 'ko' ? 'ENG' : 'KOR'))])])])])]),_vm._v(" "),(_vm.toast)?_c('div',{staticClass:"toast wow animate__animated animate__fadeOut",attrs:{"data-wow-duration":"1.5s"}},[_c('p',[_vm._v(_vm._s(_vm.toast))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main"},[_c('section',{staticClass:"visual"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".4s"}},[_vm._v(_vm._s(_vm.$t('main-title-description')))]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"resolution wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".8s"}},[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highResolution),expression:"highResolution"}],attrs:{"type":"radio","id":"high","name":"resolution"},domProps:{"value":true,"checked":_vm._q(_vm.highResolution,true)},on:{"change":function($event){_vm.highResolution=true}}}),_vm._v(" "),_c('label',{attrs:{"for":"high"}},[_vm._v("고해상도")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highResolution),expression:"highResolution"}],attrs:{"type":"radio","id":"low","name":"resolution"},domProps:{"value":false,"checked":_vm._q(_vm.highResolution,false)},on:{"change":function($event){_vm.highResolution=false}}}),_vm._v(" "),_c('label',{attrs:{"for":"low"}},[_vm._v("저해상도")])])]),_vm._v(" "),_c('div',{staticClass:"button wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".8s"}},[_c('div',{staticClass:"make"},[_c('button',{on:{"click":_vm.handleMakeBtnClick}},[_vm._v(_vm._s(_vm.$t('main-button-start')))])]),_vm._v(" "),_c('div',{staticClass:"enter",class:{ open: _vm.isCollapsedJoinBtn }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],attrs:{"type":"text","placeholder":this.$t('main-button-join-placeholder'),"inputmode":"numeric","pattern":"[0-9]*"},domProps:{"value":(_vm.url)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleJoinBtnClick($event)},"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"mouseover":_vm.handleMouseoverJoinBtn,"click":_vm.handleJoinBtnClick}},[_vm._v(_vm._s(_vm.$t('main-button-join')))])])])]),_vm._v(" "),_c('span',{staticClass:"scroll"})])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('section',{staticClass:"faq",attrs:{"id":"faq"}},[_c('div',{staticClass:"container"},[_c('h2',[_vm._v("FAQ")]),_vm._v(" "),_c('ul',[_c('li',{class:{ open: _vm.isFaqOpen }},[_c('button',{on:{"click":_vm.handleFaqBtnClick}},[_vm._v("앱에서 지원되는 버전이나 확인 된 기종은 어떤 것이 있나요?")]),_vm._v(" "),_c('div',{ref:"answer",staticClass:"answer"},[_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("브라우저는 Chrome 53버전 이상, New Edge 12버전 이상, Safari 11버전 이상에서 정상 동작합니다.")]),_vm._v(" "),_vm._m(12)])])])])]),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"link"},[_c('a',{attrs:{"href":"https://knowledgepoint.co.kr/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('main-footer-menu-1')))]),_vm._v(" "),_c('a',{attrs:{"href":"https://knowledgepoint.co.kr/developer/qna/list","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('main-footer-menu-2')))]),_vm._v(" "),_c('a',{attrs:{"href":"https://knowledgepoint.co.kr/developer/update/list","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('main-footer-menu-3')))])]),_vm._v(" "),_c('div',{staticClass:"company"},[_c('strong',[_vm._v("COCOcall "),(!_vm.isWebview)?_c('span',[_vm._v("["+_vm._s(_vm.getVersion)+"]")]):_vm._e()]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.$t('main-footer-company-name')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('main-footer-company-address')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('main-footer-company-phone'))),_c('a',{attrs:{"href":"tel:070-4325-4033"}},[_vm._v("070-4325-4033")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('main-footer-company-mail'))),_c('a',{attrs:{"href":"mailto:maverick@knowledgepoint.co.kr"}},[_vm._v("maverick@knowledgepoint.co.kr")])])])]),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("Copyright All rights reserved. Knowledgepoint Co., Ltd.")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_vm._v("COCOcall")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#information"}},[_c('span',{attrs:{"data-menu":"information"}},[_vm._v("information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#function"}},[_c('span',{attrs:{"data-menu":"function"}},[_vm._v("function")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#guide"}},[_c('span',{attrs:{"data-menu":"guide"}},[_vm._v("guide")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#download"}},[_c('span',{attrs:{"data-menu":"download"}},[_vm._v("download")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":__webpack_require__(211)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".6s"}},[_c('span',[_c('i',[_vm._v("CO")]),_vm._v("nvenient")]),_vm._v(" "),_c('span',[_c('i',[_vm._v("CO")]),_vm._v("nference")]),_vm._v(" "),_c('span',[_c('i',[_vm._v("call")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"information",attrs:{"id":"information"}},[_c('div',{staticClass:"container"},[_c('h2',[_c('div',{staticClass:"logo"},[_vm._v("COCOcall")])]),_vm._v(" "),_c('ul',[_c('li',[_c('div',{staticClass:"wow box animate__animated animate__zoomIn"},[_c('div',{staticClass:"tit"},[_c('strong',[_vm._v("CO")]),_vm._v("nvenient")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("프로그램 설치와 회원가입이 필요 없어"),_c('br'),_vm._v(" 편하게 사용할 수 있습니다.")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"wow box animate__animated animate__zoomIn"},[_c('div',{staticClass:"tit"},[_c('strong',[_vm._v("CO")]),_vm._v("nference")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("회의실이 아니어도"),_c('br'),_vm._v(" 화상으로 회의를 진행할 수 있습니다.")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"wow box animate__animated animate__zoomIn"},[_c('div',{staticClass:"tit"},[_c('strong',[_vm._v("call")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("누구나 무료로"),_c('br'),_vm._v(" 화상회의를 즐길 수 있습니다.")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"function",attrs:{"id":"function"}},[_c('div',{staticClass:"container"},[_c('ul',[_c('li',{staticClass:"wow animate__animated animate__fadeInUp"},[_c('strong',[_vm._v("비회원")]),_vm._v(" "),_c('p',[_vm._v("복잡한 회원가입 절차가"),_c('br'),_vm._v(" 필요 없습니다.")])]),_vm._v(" "),_c('li',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_c('strong',[_vm._v("프로그램 설치 없이")]),_vm._v(" "),_c('p',[_vm._v("별도의 프로그램 설치가"),_c('br'),_vm._v(" 필요 없습니다.")])]),_vm._v(" "),_c('li',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".4s"}},[_c('strong',[_vm._v("인터넷 브라우저")]),_vm._v(" "),_c('p',[_vm._v("인터넷 브라우저만으로"),_c('br'),_vm._v(" 화상회의를 할 수 있습니다. "),_c('span',[_vm._v("*Chrome browser 권장")])])]),_vm._v(" "),_c('li',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".6s"}},[_c('strong',[_vm._v("최대 16명까지")]),_vm._v(" "),_c('p',[_vm._v("최대 16명까지"),_c('br'),_vm._v(" 화상회의를 할 수 있습니다.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"guide",attrs:{"id":"guide"}},[_c('div',{staticClass:"container"},[_c('ul',[_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(212),"alt":"STEP 1"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp"},[_vm._v("STEP 1")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("메인화면에서 ‘화상회의 시작하기’ 버튼을 클릭하면 바로 화상회의가 시작됩니다.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(213),"alt":"STEP 2"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("STEP 2")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".3s"}},[_vm._v("화상 통화 시작 전에 내 이름과 사용 중인 디바이스를 확인하고 변경할 수 있습니다.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(214),"alt":"STEP 3"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("STEP 4")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".3s"}},[_vm._v("'초대하기' 버튼을 클릭 후 URL을 공유하여 사용자를 초대할 수 있습니다.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(215),"alt":"STEP 4-1"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp"},[_vm._v("STEP 4-1")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("초대받은 사용자는 인터넷 브라우저나 메인화면 '회의참여'버튼 클릭 후 URL을 입력하면 회의에 참석됩니다.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(216),"alt":"STEP 4-2"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp"},[_vm._v("STEP 4-2")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("COCOcall 실행 중 다른 회의에 연결하고 싶으시다면 메뉴에서 '다른 회의 참여하기' 버튼을 클릭 후 URL을 입력하세요.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(217),"alt":"STEP 5"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("STEP 5")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".3s"}},[_vm._v("본인의 카메라, 오디오를 On/Off 할 수 있습니다.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(218),"alt":"STEP 6"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp"},[_vm._v("STEP 6")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("내 이름을 원하는 대로 수정할 수 있습니다. "),_c('br'),_vm._v(" "),_c('span',[_vm._v("*최초에는 '익명'으로 표시됩니다.")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(219),"alt":"STEP 7"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("STEP 7")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".3s"}},[_vm._v("'화면공유' 버튼을 클릭하면 본인의 화면을 공유할 수 있습니다. "),_c('span',[_vm._v("*PC에서만 제공됩니다.")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(220),"alt":"STEP 8"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp"},[_vm._v("STEP 8")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("화자 감지 기능을 활성화해보세요. 현재 발언하는 화자를 더욱 손쉽게 알 수 있습니다.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(221),"alt":"STEP 9"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("STEP 9")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".3s"}},[_vm._v("사생활 보호 기능을 활성화해보세요. 얼굴을 제외한 배경을 Blur 처리하여 사생활을 보호하며 화상 회의를 할 수 있습니다.")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":__webpack_require__(222),"alt":"STEP 10"}})]),_vm._v(" "),_c('strong',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".2s"}},[_vm._v("STEP 10")]),_vm._v(" "),_c('p',{staticClass:"wow animate__animated animate__fadeInUp",attrs:{"data-wow-delay":".3s"}},[_vm._v("오디오세이프 기능이 적용되어 있어 네트워크 상태가 불안정할 경우 영상 송수신을 제어하고 음성만 제공하여 서비스를 중단 없이 안정성 있게 제공합니다.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("안드로이드"),_c('br'),_vm._v("\n                단말 : 갤럭시 S8, 갤럭시 S8+, 갤럭시 S9, 갤럭시노트 5(App 미호환/사용 불가), 갤럭시노트 9, 갤럭시노트 10+, LG V50, 갤럭시탭A 2016"),_c('br'),_vm._v("\n                OS 버전 : 안드로이드 6.0(App 미호환/사용 불가), 안드로이드 8.1, 안드로이드 9.0, 안드로이드 10")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("iOS"),_c('br'),_vm._v("\n                단말 : iPhone 6S, iPhone XS, iPhone 12, iPhone 12 Pro, iPad Pro 9.7"),_c('br'),_vm._v("\n                OS 버전 : iOS 14.1, iOS 14.2, iPadOS 14.2"),_c('br'),_vm._v("\n                * iOS에서 COCOcall을 사용하실 때는 가로/세로 전환 고정을 해제해주세요.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("위에 명시 된 버전/기종이 아닐 때 사용 간 문제가 발생하신 경우 아래 링크에 문의를 남겨주세요."),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://knowledgepoint.co.kr/developer/qna/list","target":"_blank"}},[_vm._v("문의하기 바로가기")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"download",attrs:{"id":"download"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"logo"},[_vm._v("COCOcall")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('span',[_vm._v("간편하게 즐기는 무료 화상 회의,")]),_vm._v(" "),_c('p',[_vm._v("COCOcall을 APP을 만나보세요!")])]),_vm._v(" "),_c('div',{staticClass:"link"},[_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=kr.co.knowledgepoint.knowledgetalkccc","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(223),"alt":"GET IT ON Google Play"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://apps.apple.com/kr/app/cococall/id1533624306","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(224),"alt":"Download on the App Store"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg.38b10a0.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_01.bd545ba.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_02.be564b7.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_03.933d7a1.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_04-1.5a3a2b9.jpg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_04-2.ea8e767.jpg";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_05.256b35a.jpg";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_06.c9c898b.jpg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_07.c0772bc.jpg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_08.6ebb4ea.jpg";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_09.81457ba.jpg";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_guide_10.e251f69.jpg";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_app_download.e0ccddf.png";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_app_download2.3837e91.png";

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Call_vue__ = __webpack_require__(106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0b3136_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Call_vue__ = __webpack_require__(232);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Call_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0b3136_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Call_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de0a89b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__ = __webpack_require__(227);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de0a89b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"video",staticClass:"video",class:{ 
         'local': this.isLocalVideo, 
         'camOff': this.offVideo, 
         'talking': this.isTalking, 
         'networkCheck': this.isNetworkBad },attrs:{"id":this.id}},[_c('canvas',{ref:"canvas",style:({'display': 'none'}),attrs:{"hidden":""}}),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.isNetworkBad)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("인터넷 상태가 좋지 않아 영상 송출이 잠시 중단됩니다.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"userContainer"},[_c('div',{staticClass:"user"},[_c('span',{staticClass:"name",class:{ 'micOff': _vm.offMic }},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.id === 'local')?_c('button',{on:{"click":_vm.handleChangeName}},[_vm._v("이름변경")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"volume"},[_c('div',{staticClass:"percent"},[_c('span'),_c('span'),_c('span'),_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffVideo_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_758af62a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffVideo_vue__ = __webpack_require__(229);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_758af62a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video off"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20eb789a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__ = __webpack_require__(231);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20eb789a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"buttonContainer"},[_c('div',{staticClass:"button wow animate__animated animate__fadeInUp animate__faster"},[_c('ul',[_c('li',[_c('button',{staticClass:"invite",on:{"click":_vm.handleInviteBtn}},[_c('span',[_vm._v(_vm._s(this.$t('button-invite')))])])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"share",on:{"click":_vm.handleScreenShareBtn}},[_c('span',[_vm._v(_vm._s(this.$t('button-share')))])])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"camera",class:{off: _vm.isOffVideo},on:{"click":_vm.handleCamBtn}},[_c('span',[_vm._v(_vm._s(this.$t('button-camera')))])])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"mic",class:{off: _vm.isOffMic},on:{"click":_vm.handleMicBtn}},[_c('span',[_vm._v(_vm._s(this.$t('button-microphone')))])])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"more",on:{"click":function(){_vm.showsMore = !_vm.showsMore}}},[_c('span',[_vm._v(_vm._s(this.$t('button-more')))])]),_vm._v(" "),(_vm.showsMore)?_c('div',{staticClass:"dropdown"},[_c('ul',[(!_vm.isMobile)?_c('li',[_c('button',{staticClass:"enter",on:{"click":_vm.handleJoinBtn}},[_c('span',[_vm._v(_vm._s(this.$t('button-another-meeting')))])])]):_vm._e()]),_vm._v(" "),_c('ul',[_c('li',[_c('button',{staticClass:"talking",on:{"click":_vm.handleTalkingBtn}},[_c('span',[_vm._v(_vm._s(_vm.btnStrTalking))])])]),_vm._v(" "),(!_vm.isMobile)?_c('li',[_c('button',{staticClass:"bgBlur",on:{"click":_vm.handleBgBlurBtn}},[_c('span',[_vm._v(_vm._s(_vm.btnStrBlur))])])]):_vm._e()]),_vm._v(" "),_c('ul',[(!_vm.isMobile)?_c('li',[_c('button',{staticClass:"setting",on:{"click":_vm.handleSettingBtn}},[_c('span',[_vm._v(_vm._s(this.$t('button-setting')))])])]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('li',[_c('button',{staticClass:"endCall",on:{"click":_vm.handleEndCallBtn}},[_vm._v(_vm._s(this.$t('button-end-call')))])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoWrapper"},[(_vm.popup.on)?_c('Popup',{attrs:{"type":_vm.popup.type,"title":_vm.popup.title,"contents":_vm.popup.contents,"option":_vm.popup.option,"ok":_vm.handlePopupOkBtnClick,"cancel":_vm.handlePopupCancelBtnClick}}):_vm._e(),_vm._v(" "),(_vm.toast)?_c('div',{staticClass:"toast wow animate__animated animate__fadeOut",attrs:{"data-wow-duration":"1.5s"}},[_c('p',[_vm._v(_vm._s(_vm.toast))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"videoContainer",class:{close: _vm.isCollapsedVideo},attrs:{"id":"VideoContainer"}},[_c('div',{ref:"share",staticClass:"shareContainer",style:({display: (_vm.share ? 'block' : 'none')}),on:{"mouseover":_vm.handleBtnArea,"click":_vm.handleBtnArea}},[_c('div',{staticClass:"shareVideo"},[_c('div',{staticClass:"video",style:({display: (_vm.share && !_vm.share.isSharer ? 'block' : 'none')})},[_c('video',{attrs:{"id":"ShareVideo"}})]),_vm._v(" "),(_vm.share && _vm.share.isSharer)?_c('div',{staticClass:"share"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":__webpack_require__(233),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('call-share-contents-1'))),_c('br'),_vm._v("\n              "+_vm._s(_vm.$t('call-share-contents-2')))]),_vm._v(" "),_c('button',{on:{"click":_vm.handleShareEndBtnClick}},[_vm._v(_vm._s(_vm.$t('call-share-button')))])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mainVideoContainer",style:({display:_vm.share ? 'block' : 'none'}),attrs:{"id":"MainVideoContainer"},on:{"mouseover":_vm.handleBtnArea}},[_c('div',{staticClass:"button"},[_c('button',{on:{"click":_vm.handleCollapseBtnClick}},[_vm._v("열기")])])]),_vm._v(" "),_c('div',{ref:"mainVideo",staticClass:"mainVideo",class:_vm.videoDisplayType,attrs:{"id":"MainVideo"},on:{"mouseover":_vm.handleBtnArea,"click":_vm.handleBtnArea}},[_vm._l((_vm.videos),function(v){return [_c('Video',{key:v.id,attrs:{"isOffVideo":v.isOffVideo,"isOffMic":v.isOffMic,"isBgBlur":v.isBgBlur,"isLocal":v.isLocal,"vid":v.id,"userName":v.userName},on:{"mouseover":_vm.handleBtnArea,"click":_vm.handleBtnArea}})]}),_vm._v(" "),_vm._l((_vm.offVideos),function(v,idx){return [_c('OffVideo',{key:idx,on:{"mouseover":_vm.handleBtnArea,"click":_vm.handleBtnArea}})]})],2)]),_vm._v(" "),(_vm.buttonInfo)?_c('div',{staticClass:"buttonInfo",on:{"click":_vm.handleBtnArea}},[_c('strong',[_vm._v("MENU")]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.buttonInfo.message))]),_c('br'),_vm._v("  "+_vm._s(_vm.$t('call-menu-information-2')))])]):_vm._e(),_vm._v(" "),_c('div',{ref:"btnArea",staticStyle:{"position":"fixed","display":"flex","justify-content":"center","align-items":"flex-end","width":"100%","bottom":"0","height":"20px"},on:{"mouseover":_vm.handleBtnArea,"mouseleave":_vm.handleBtnArea}}),_vm._v(" "),_c('Buttons',{ref:"btn",staticClass:"wow animate__animated animate__fadeIn animate__faster",attrs:{"isVisible":_vm.visibleBtnArea},on:{"mouseover":_vm.handleBtnArea}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_screen_share_sharing.ffcb577.gif";

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entrance_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6346753c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entrance_vue__ = __webpack_require__(235);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entrance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6346753c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entrance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"videoWrapper"},[(_vm.appModal)?_c('app-modal',{attrs:{"close":_vm.handleAppModalClose}}):_vm._e(),_vm._v(" "),(_vm.popup.on)?_c('Popup',{attrs:{"type":_vm.popup.type,"title":_vm.popup.title,"contents":_vm.popup.contents,"option":_vm.popup.option,"ok":_vm.popup.ok,"cancel":_vm.popup.cancel}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"lobbyContainer"},[_c('button',{staticClass:"close",on:{"click":function($event){return _vm.closeEntrance()}}}),_vm._v(" "),_c('div',{staticClass:"lobbyContent"},[_c('div',{staticClass:"logo"},[_vm._v("COCOcall")]),_vm._v(" "),_c('div',{staticClass:"video",class:_vm.offVideo ? 'camOff' : ''},[_c('video',{ref:"video",style:(_vm.offVideo? "display: none" : "display: block")}),_vm._v(" "),_c('div',{staticClass:"button controller"},[_c('button',{staticClass:"camera",class:_vm.offVideo ? 'off' : '',on:{"click":function($event){_vm.offVideo = !_vm.offVideo}}}),_vm._v(" "),_c('button',{staticClass:"mic",class:_vm.offMic ? 'off' : '',on:{"click":function($event){_vm.offMic = !_vm.offMic}}})]),_vm._v(" "),(!_vm.isMoblile)?_c('div',{staticClass:"button"},[_c('button',{staticClass:"setting",on:{"click":function($event){return _vm.handleSettingBtn()}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"userContainer"},[_c('div',{staticClass:"user"},[_c('span',{staticClass:"name",class:_vm.offMic ? 'micOff' : ''},[_vm._v(_vm._s(_vm.name === '' ? '익명' : _vm.name))])])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"name"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{attrs:{"type":"text","placeholder":"익명","maxlength":"8"},on:{"input":_vm.typingName,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleStartBtn()}}})])]),_vm._v(" "),_c('div',{staticClass:"button"},[_c('button',{on:{"click":function($event){return _vm.handleStartBtn()}}},[_vm._v("참여하기")])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_vm._v("이름을 입력해주세요. "),_c('span',[_vm._v("* 이름을 입력하지 않으면 ‘익명’으로 표시됩니다.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(237);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(238);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: Object({"NODE_ENV":"production"}).VUE_APP_I18N_LOCALE || 'ko',
  fallbackLocale: Object({"NODE_ENV":"production"}).VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 239,
	"./ko.json": 240
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 238;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = {"_____COMMENT1_____":"--------------------  Main  -------------------","main-title-description":"simply start a free video conference,","main-button-start":"Start","main-button-join":"Join","main-button-join-placeholder":"Enter the URL or room number.","main-footer-menu-1":"About us","main-footer-menu-2":"Questions","main-footer-menu-3":"Notice/Update","main-footer-menu-4":"App Download","main-footer-company-name":"Knowledgepoint Co., Ltd.","main-footer-company-address":"Address : 16, Saimdang-ro 8-gil, Seocho-gu, Seoul, Republic of Korea","main-footer-company-phone":"Phone : ","main-footer-company-mail":"Mail : ","_____COMMENT2_____":"--------------------  Call  -------------------","call-menu-information-pc-1":"You can check the menu by hovering the mouse at the bottom of the screen.","call-menu-information-app-1":"You can check the menu by touching the screen.","call-menu-information-2":"","call-share-contents-1":"Screen sharing is in progress.","call-share-contents-2":"Click the button below to end screen sharing.","call-share-button":"End screen sharing","_____COMMENT3_____":"--------------------     Popup     -------------------","popup-join-failed-title":"Failure to join the conference","popup-join-failed-contents-1":"Enter the URL or room number to join.","popup-join-failed-contents-2":"Please enter the URL or number you received.","popup-setting-devices-title":"Device setting","popup-setting-devices-contents-1":"Check that the camera and microphone are working before calling","popup-setting-devices-contents-2":"Device settings cannot be changed after entering.","popup-change-name-title":"Change Name","popup-change-name-contents":"Please enter your name.","popup-change-name-placeholder":"Please enter your name.","popup-change-name-complete":"The name has been changed.","popup-end-call-title":"End Call","popup-end-call-contents":"Do you want to end the call?","popup-another-meeting-title":"Join another conference","popup-another-meeting-placeholder":"Enter the URL or room number.","popup-another-meeting-complete":"will be move to the meeting room soon...","popup-another-meeting-failed":"Enter the URL or room number to join.","popup-invite-title":"Invite","popup-invite-kakao":"kakaotalk","popup-invite-mms":"MMS","popup-invite-url":"Copy URL","popup-invite-url-complete":"The URL has been copied.","popup-invite-soon":"This feature is currently being prepared.","popup-screen-share-title":"Screen Sharing","popup-screen-share-contents-failed-1":"Screen sharing is not possible yet.","popup-screen-share-contents-failed-2":"Screen sharing is not possible on mobile devices.","popup-checkbox-1":"Don't see it again next time","popup-submit":"OK","popup-start":"Start","popup-cancel":"Cancel","popup-refresh":"Refresh","_____COMMENT4_____":"-------------------- etc components -------------------","button-another-meeting":"Join another conference","button-invite":"Invite","button-share":"Screen sharing","button-camera":"Camera","button-microphone":"Microphone","button-more":"More","button-all-cam-on":"모든 카메라 ON","button-all-cam-off":"모든 카메라 OFF","button-shows-speaker-on":"화자 감지 on","button-shows-speaker-off":"화자 감지 off","button-bg-blur-on":"사생활 보호 on","button-bg-blur-off":"사생활 보호 off","button-setting":"Settings","button-end-call":"End Call"}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = {"_____COMMENT1_____":"--------------------  Main 페이지  -------------------","main-title-description":"간편하게 즐기는 무료 화상 회의,","main-button-start":"회의시작","main-button-join":"회의참여","main-button-join-placeholder":"URL 또는 방 번호(8자리)를 입력하세요.","main-footer-menu-1":"회사소개","main-footer-menu-2":"문의사항","main-footer-menu-3":"공지/업데이트","main-footer-menu-4":"App 다운로드","main-footer-company-name":"(주)날리지포인트","main-footer-company-address":"주소 : 서울시 서초구 사임당로 8길 16 2층 (성재빌딩)","main-footer-company-phone":"전화 : ","main-footer-company-mail":"메일주소 : ","_____COMMENT2_____":"--------------------  Call 페이지  -------------------","call-menu-information-pc-1":"화면 하단에 마우스를 가져가면","call-menu-information-app-1":"화면을 터치하면","call-menu-information-2":"메뉴를 확인 하실 수 있습니다.","call-share-contents-1":"화면 공유중입니다.","call-share-contents-2":"화면 공유를 종료하시려면 아래 버튼을 클릭해주세요.","call-share-button":"화면 공유 종료","_____COMMENT3_____":"--------------------     Popup     -------------------","popup-join-failed-title":"회의 참여 실패","popup-join-failed-contents-1":"참여 하실 URL 또는 방 번호를 입력하세요.","popup-join-failed-contents-2":"전달 받은 URL 또는 번호를 정확히 입력해주세요.","popup-setting-devices-title":"디바이스 설정","popup-setting-devices-contents-1":"통화 시작 전 카메라와 마이크가 정상 동작하는지 확인하세요.","popup-setting-devices-contents-2":"입장 후에는 디바이스 설정을 변경할 수 없습니다.","popup-change-name-title":"이름 변경","popup-change-name-contents":"이름을 입력하세요.","popup-change-name-placeholder":"이름을 입력하세요.","popup-change-name-complete":"이름이 변경 되었습니다.","popup-end-call-title":"통화 종료","popup-end-call-contents":"통화를 종료 하시겠습니까?","popup-another-meeting-title":"다른 회의 참여하기","popup-another-meeting-placeholder":"URL 또는 방 번호(8자리)를 입력하세요.","popup-another-meeting-complete":"잠시 후 다른 회의 방으로 이동합니다.","popup-another-meeting-failed":"참여 하실 URL 또는 방 번호를 입력하세요.","popup-invite-title":"사용자 초대하기","popup-invite-kakao":"카카오톡","popup-invite-mms":"문자메시지","popup-invite-url":"URL 복사","popup-invite-url-complete":"URL이 복사되었습니다.","popup-invite-soon":"현재 준비 중인 기능입니다.","popup-screen-share-title":"화면 공유","popup-screen-share-contents-failed-1":"지금은 화면공유를 진행할 수 없습니다.","popup-screen-share-contents-failed-2":"모바일 기기에서는 화면공유를 진행할 수 없습니다.","popup-checkbox-1":"다음 부터 다시 보지 않기","popup-submit":"확인","popup-start":"시작","popup-cancel":"취소","popup-refresh":"새로고침","_____COMMENT4_____":"-------------------- etc components -------------------","button-another-meeting":"다른 회의 참여하기","button-invite":"초대하기","button-share":"화면공유","button-camera":"카메라","button-microphone":"마이크","button-more":"더보기","button-all-cam-on":"모든 카메라 ON","button-all-cam-off":"모든 카메라 OFF","button-shows-speaker-on":"화자 감지 활성화","button-shows-speaker-off":"화자 감지 비활성화","button-bg-blur-on":"사생활 보호 활성화","button-bg-blur-off":"사생활 보호 비활성화","button-setting":"설정","button-end-call":"통화 종료"}

/***/ })
],[111]);


// WEBPACK FOOTER //
// static/js/app.f17825d24e1fced5b127.js